/* eslint-disable no-inner-declarations */
import {
    getCanvasElementTitle,
    selectCanvasElements,
    toggleElementLock,
    toggleElementVisibility,
    toggleElementOverlay,
    focusCanvas,
    updateCanvasSelection,
    updateElementsOrderFromZIndex
} from '@/utils/elementsUtils';
import { setQrData } from '@/utils/qrCodeUtils';
import { buildCloudFrontUrl } from '@/utils/pathUtils';
import { imageToBlob, handleDownloadCurrentCanvasAsImage, loadImageFromBlob } from '@/utils/imageUtils';
import { UndoRedoManager } from '@/utils/undoRedoManager/undoRedoManager.js';
import * as starMapUtils from '../../services/util/starMapUtils';
import { createTextEffect, createTextEffectHandlers, cleanupDeletedTextEffects } from '@/utils/textMaskEffects';
import { createTextPatternHandlers, computeCellPosition } from '@/utils/textPatternEffects';
import ImageFilter from '@/typings/ImageFilter';
import { generateCustomilyCalendar } from '@/utils/customilyCalendarUtils';
import fontManagerService from '@/utils/fontManagerService';
import { delay } from '@/utils/timingUtils';
import { resolveStep2LoadDecision } from '../../services/util/groups/step2LoadDecision';
import { cloneDeep } from 'lodash';
import { IndexDbService } from '../../services/util/indexDbService';
import { ImageEffectsService } from '@/utils/imageEffectsService';
import useGroupManager from '@/modules/layers/composables/useGroupManager';
import { ValueFormat } from '@/typings/designStudio/sourceElementTypes';
import { recordFeatureUsage, TrackedFeature } from '@/utils/featureUsage';

const isPrintSizeVariant = 'isprintsizevariant';

(function () {
    'use strict';
    'ngInject';

    angular.module('app.ctrls').controller('CreateStepTwoCtrl', createStepTwoCtrl);

    function createStepTwoCtrl(
        $scope,
        ProductService,
        ImageUtilService,
        MultipleFontService,
        $timeout,
        $location,
        $mdDialog,
        $rootScope,
        $sce,
        blockUI,
        TestImageService,
        ColorSamplerService,
        GeneralMathUtils,
        TextService,
        DynamicVectorService,
        DynamicImageService,
        MultipleFileUploadService,
        TextureService,
        LibrariesUtilService,
        LibrariesAPIService,
        ConfigService,
        ElementsColorService,
        AppCuesService,
        RemoveBgAPIService,
        PreviewUtilService,
        CutoutProUtilService,
        CustomilyRmbgService,
        CustomilyFaceCutOutService,
        CustomilyImageFilterService,
        CrosswordService,
        QrUtilService
    ) {
        $rootScope.headerMode = 'single';

        // Max image size to be used in the preview for background or when uploading dynamic images
        $scope.MAX_IMAGE_SIZE = ConfigService.MAX_PREVIEW_IMAGE_SIZE;

        $scope.backgroundType = null;

        $scope.previewMode = $location.$$path == '/createProduct3';
        const preview = ProductService.getPreview();
        // We'll consider that the user is editing an existing object if the preview had loaded text or pictures
        $scope.editMode =
            preview?.textsPreview?.length > 0 ||
            preview?.imagePlaceHoldersPreview?.length > 0 ||
            preview?.circularTextsPreview?.length > 0 ||
            preview?.vectorEPSPreview?.length > 0;
        $scope.colorSamplerActive = false;
        $scope.replacedBackground = false;
        $scope.textures = [];
        $scope.crosswordTextures = [];
        $scope.canRemoveSelection = false;

        // Library names
        $scope.selectedColorLibraryName = '';
        $scope.selectedFontLibraryName = '';
        $scope.selectedImageLibraryName = '';
        $scope.selectedVectorLibraryName = '';

        $scope.selectedSpotifyPlayer = null;
        $scope.textAsMaskStoredObjects = {};

        // Objects selection and properties
        $scope.textSelected = null;
        $scope.imageSelected = null;
        $scope.selectedTextProperties = {
            text: '',
            centerX: 0,
            centerY: 0,
            rotation: 0,
            fontPath: '',
            fontName: '',
            color: '#000000',
            id: 0,
            skewX: 0,
            skewY: 0,
            outlineWidth: 0,
            fontOption: 0,
            fontColorOption: 1,
            textures: [],
            locked: true,
            prefix: '',
            suffix: '',
            betweenCharacters: '',
            betweenWords: '',
            flipX: false,
            flipY: false,
            textureScale: 100,
            useAsMask: false,
            useAsCutout: false
        };
        $scope.textOutlineColorPicker = ColorSamplerService.createEmptyColorPicker();

        $scope.selectedImageProperties = {
            centerX: 0,
            centerY: 0,
            rotation: 0,
            id: 0,
            fullColor: true,
            grading: false,
            opacity: 1,
            skewX: 0,
            skewY: 0,
            width: 0,
            height: 0,
            dynamicImageVariation: 1,
            dynamicImagesPath: null,
            colorPosition: 1,
            removeWhiteBackground: false,
            RemoveBackground: false,
            locked: true,
            flipX: false,
            flipY: false,
            CrosswordConfig: null,
            calendarConfig: null,
            imageToImage: false,
            imageToImageConfig: null,
            imageEffects: null,
            clipPath: { scaleX: 1, x: 0, y: 0 },
            pageEpsId: undefined,
            allowSwapLibraryPosition: false,
            limitMovement: false,
            hasTextMask: false
        };
        $scope.imageColorPicker = ColorSamplerService.createEmptyColorPicker();
        $scope.imageOutlineColorPicker = ColorSamplerService.createEmptyColorPicker();
        $scope.hasSelectedElement = false;
        $scope.hasLockedSelectedElement = false;
        $scope.apiKeys = {
            removeBg: null,
            cutoutPro: null
        };

        // SVG Group
        $scope.svgSelected = null;
        $scope.selectedSVGProperties = {
            centerX: 0,
            centerY: 0,
            skewX: 0,
            skewY: 0,
            rotation: 0,
            width: 0,
            height: 0,
            id: 0,
            position: 1,
            allowUserUpload: false,
            colorPosition: 1,
            applyColoring: false,
            isSolidBackground: false,
            locked: true,
            flipX: false,
            flipY: false,
            allowEdit: false,
            allowSwapLibraryPosition: false
        };

        // Selected Object Group
        $scope.selectedObjectGroup = null;
        $scope.selectedObjectGroupProperties = {
            centerX: 0,
            centerY: 0,
            rotation: 0,
            width: 0,
            height: 0,
            locked: true,
            objectCount: 0
        };

        $scope.shProduct = $rootScope.shProduct;
        $scope.layersInstance = null;
        $scope.forProductTemplateCreation = !!$location.search().forProductTemplateCreation;
        $scope.hideMultiPreviewActions = false;
        $scope.isUserDesignCreation = !!$location.search().forUserDesignCreation;
        $scope.forMyProductBases = !!$location.search().forMyProductBases;
        $scope.enablePageEpsForPods = !!$location.search().enablePageEpsForPods;
        $scope.isPrintfulOrPrintify = $location.search().pod === 'Printful' || $location.search().pod === 'Printify';
        $scope.fromListing = !!$location.search().fromListing || false;
        $scope.elementAlignType = 'selection';
        $scope.enablePageEps =
            $scope.isPrintfulOrPrintify ||
            $scope.enablePageEpsForPods ||
            $scope.forMyProductBases ||
            !(
                $scope.isUserDesignCreation ||
                $scope.createDesignOnTemplate ||
                $scope.forDesignTemplateCreation ||
                $scope.forMyDesigns
            );

        $scope.showResetLayerModal = false;

        $scope.showPreviewBackgroundModal = false;
        $scope.productPreviewBackground = undefined;
        // 'reset' reloads the whole preview from scratch, 'replace' only swaps the
        //  background/size keeping the existing canvas elements.
        $scope.previewBackgroundMode = 'reset';

        $scope.isPreviewElement = false;
        $scope.provider = ProductService.getPod()?.apiKeyReference;
        $scope.isParentOrChildTemplateProduct = null;
        const { init: initGroupManager, get: getGroupManager } = useGroupManager();

        $scope.isGroupSelected = function () {
            if ($scope.isUserDesignCreation && !$scope.previewMode) {
                // If user is modifying a design all element should be treated as a group
                return true;
            } else {
                return canvas.getActiveObjects().length > 1;
            }
        };

        $scope.IndexDbService = new IndexDbService();

        const skipSaveTestingValues = $rootScope?.user?.AccessRoles?.Serialized?.split(',')?.includes(
            'skip-save-testing-values'
        );

        $scope.$watch('layersInstance', (instance) => {
            $scope.layersInstance = instance;
        });

        $scope.showBlockUiLoader = function (active, message = 'Loading...') {
            $scope.$evalAsync(() => {
                if (!active) {
                    blockUI.stop();
                    return;
                }

                if (blockUI.state().blocking) {
                    blockUI.message(message);
                    return;
                }

                blockUI.start(message);
            });
        };

        $scope.layersElementLockToggle = function (data) {
            if ($rootScope.isManagedUser && !$rootScope.user.UserImpersonatedFromId) return;
            toggleElementLock(data.element, canvas);

            const object = canvas.getActiveObject();
            if (object) {
                object.fire('modified');
            }

            $timeout(() => $scope.$apply());
            updateCanvasSelection(canvas);
            focusCanvas(canvas);
        };

        $scope.layersElementVisibilityToggle = function (data) {
            toggleElementVisibility(data.element, canvas);
            updateCanvasSelection(canvas);
            focusCanvas(canvas);
        };

        $scope.layersElementOverlayToggle = function (data) {
            toggleElementOverlay(data.element, canvas);
            updateCanvasSelection(canvas);
            focusCanvas(canvas);
        };

        $scope.resetPreviewToggle = function () {
            $scope.isResetPreview = !$scope.isResetPreview;
        };

        $scope.layersTitleChange = function (data) {
            if ($scope.editMode && data.element.setEditedProp) {
                data.element.setEditedProp('name');
            }
            focusCanvas(canvas);
        };

        $rootScope.$watch('user', (user) => {
            if (!user) return;
            $scope.apiKeys = {
                removeBg: user.RemoveBgAPIKey,
                cutoutPro: user.CutoutproAPIKey
            };
        });

        if (AppCuesService.getCurrentFlow() == AppCuesService.WelcomeFlowCPart1) {
            window.Appcues?.show(AppCuesService.WelcomeFlowCPart2);
        }

        // Load Textures on startup
        $scope.loadTextures = function () {
            TextureService.getAllTextures().then(function (textures) {
                console.log('Textures Loaded');
                $scope.textures = textures;

                $scope.textures.forEach((texture) => {
                    texture.Name = texture.Name.replace(/\.[^/.]+$/, '');
                });
            });
        };

        $scope.toRgbaString = function (hex, alpha) {
            let converter = new Colors();
            let rgb = converter.convertColor(hex.replace('#', ''), 'HEX2RGB');
            return 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + alpha + ')';
        };

        // We'll load textures only if there is text to apply them to
        const listEps = ProductService.getListEPS();
        if (listEps.length > 0 && listEps.some((s) => s.textsEps.length > 0)) {
            $scope.loadTextures();
        }

        $scope.isPreviewOnlyElement = function (object) {
            return ProductService.isPreviewOnlyElement(object);
        };

        const canDeleteObject = function (object) {
            return !(object instanceof fabric.Object) || $scope.isPreviewOnlyElement(object);
        };

        $scope.undoManager = new UndoRedoManager();

        let canvas = new fabric.CanvasEx('fabric-canvas-2', {
            eventContainer: !$scope.previewMode ? 'fabric-container-2' : '',
            altActionKey: 'ctrlKey', // So we can control skew with the mouse
            preserveObjectStacking: true,
            seamLessScrollbars: $scope.previewMode,
            enableZoom: !$scope.previewMode,
            artworkTitle: $scope.previewMode ? 'Preview' : '',
            isPreviewStep: true,
            enableCopyPaste: function (objects) {
                if (objects.length && !$scope.isUserDesignCreation) {
                    // If any of the selected objects is not a preview-only object, don't allow copy-pasting
                    for (const object of objects) {
                        if (!$scope.isPreviewOnlyElement(object) || object.isColorOptions) {
                            return false;
                        }
                    }
                }
                return true;
            },
            enableGroups: $scope.enableGroups,
            undoManager: $scope.undoManager,
            enablePageEps: $scope.enablePageEps,
            editMode: $scope.editMode,
            displayGuidelines: true,
            enableSelectionToolbar: !$scope.previewMode
        });
        canvas.canDeleteObject = canDeleteObject;
        $scope.canvas = canvas;
        initGroupManager(canvas);

        $scope.stepTwoLayersSettingsProps = {
            canvas: $scope.canvas
        };

        // Passed to ElementTransformProperties so bulk edit can keep mask-linked pairs rigid
        $scope.getElementsLinks = function () {
            return ProductService.getElementsLinks();
        };

        $scope.loadSelectedObjectGroupData = function (evt) {
            if (canvas.getActiveObject()?.isType('activeSelection')) {
                $scope.selectedObjectGroup = canvas.getActiveObject();
            } else {
                canvas.off('object:modified', $scope.loadSelectedObjectGroupData);
                canvas.off('customilyActiveSelection:modified');
                $scope.selectedObjectGroup = null;
                return;
            }

            const point = $scope.selectedObjectGroup.getPointByOrigin('center', 'center');

            if (!evt || evt.skipCenterX === undefined || !evt.skipCenterX) {
                $scope.selectedObjectGroupProperties.centerX = point.x;
            }
            if (!evt || evt.skipCenterY === undefined || !evt.skipCenterY) {
                $scope.selectedObjectGroupProperties.centerY = point.y;
            }
            if (!evt || evt.skipRotation === undefined || !evt.skipRotation) {
                $scope.selectedObjectGroupProperties.rotation = $scope.selectedObjectGroup.angle;
            }
            if (!evt || evt.skipWidth === undefined || !evt.skipWidth) {
                $scope.selectedObjectGroupProperties.width = $scope.selectedObjectGroup.getScaledWidth();
            }
            if (!evt || evt.skipHeight === undefined || !evt.skipHeight) {
                $scope.selectedObjectGroupProperties.height = $scope.selectedObjectGroup.getScaledHeight();
            }
            $scope.selectedObjectGroupProperties.locked = false;
            $scope.selectedObjectGroupProperties.objectCount = $scope.selectedObjectGroup.getObjects()?.length;

            $timeout(function () {
                $scope.$apply();
            });
        };

        const itemSelected = function (event) {
            const target = event.target;
            // If the target is a perspective control, don't allow the selection
            if (target?.isPerspectiveControl) {
                return;
            }

            $scope.canRemoveSelection = canDeleteObject(canvas.getActiveObject());
            $scope.isPreviewElement = ProductService.isPreviewOnlyElement(canvas.getActiveObject());
            // Disable multiple elements control when a locked element is selected
            $scope.hasLockedSelectedElement =
                canvas.getActiveObject().locked || canvas.getActiveObject()?._objects?.some((item) => item.locked);
            // When selection multiple elements, disable the control panel
            if ($scope.isGroupSelected() && event.target.type === 'activeSelection') {
                event.target.set('lockUniScaling', true);
                // Hide non-uniform scaling controls for multiple selections to prevent proportion loss
                event.target.set('_controlsVisibility', {
                    ml: false, // middle left (scaleX)
                    mr: false, // middle right (scaleX)
                    mt: false, // middle top (scaleY)
                    mb: false, // middle bottom (scaleY)
                    tl: true, // top left (uniform scaling)
                    tr: true, // top right (uniform scaling)
                    bl: true, // bottom left (uniform scaling)
                    br: true // bottom right (uniform scaling)
                });
                canvas.requestRenderAll();
                $scope.hasSelectedElement = true;

                if ($scope.selectedObjectGroup !== event.target) {
                    $scope.selectedObjectGroup = event.target;
                }

                if (!$scope.selectedObjectGroup && canvas.getActiveObject()?.isType('activeSelection')) {
                    $scope.selectedObjectGroup = canvas.getActiveObject();
                }

                $scope.loadSelectedObjectGroupData();

                canvas.on('object:modified', $scope.loadSelectedObjectGroupData);
                canvas.on('customilyActiveSelection:modified', $scope.loadSelectedObjectGroupData);

                setTimeout(function () {
                    $scope.$apply();
                });
            } else {
                if (!$scope.isUserDesignCreation) {
                    $scope.hasSelectedElement = true;

                    // Terminate all opened color pickers so they can restore the current element color if it wasn't saved and
                    //  other element was now selected
                    $scope.textOutlineColorPicker.terminate();
                    $scope.imageColorPicker.terminate();
                    $scope.imageOutlineColorPicker.terminate();

                    $scope.textSelected = null;
                    $scope.imageSelected = null;
                    $scope.svgSelected = null;

                    if ($scope.selectedObjectGroup) {
                        canvas.off('object:modified', $scope.loadSelectedObjectGroupData);
                        canvas.off('customilyActiveSelection:modified');
                        $scope.selectedObjectGroup = null;
                    }

                    const activeObject = canvas.getActiveObject();
                    if (!activeObject) return;

                    canvas.updateCornerSize(activeObject);

                    const parentGroupId = activeObject?.groupId;
                    if (parentGroupId) {
                        const mgr = getGroupManager();
                        const parentGroup = mgr?.getGroup(parentGroupId);
                        if (parentGroup && parentGroup.SpotifyPlayer) {
                            $scope.selectedSpotifyPlayer = parentGroup;
                        } else {
                            $scope.selectedSpotifyPlayer = null;
                        }
                    } else {
                        $scope.selectedSpotifyPlayer = null;
                    }

                    // Text selected
                    if (activeObject.type === 'bounded-text' || activeObject.type === 'text-transform') {
                        $scope.textSelected = activeObject;
                        LibrariesUtilService.updateLibraryNames($scope, $scope.textSelected);

                        // eslint-disable-next-line no-inner-declarations
                        function loadTextData() {
                            if (!$scope.textSelected) {
                                return;
                            }
                            // Load data
                            $scope.selectedTextProperties.text = $scope.textSelected.getText();
                            $scope.selectedTextProperties.centerX = $scope.textSelected.left;
                            $scope.selectedTextProperties.centerY = $scope.textSelected.top;
                            $scope.selectedTextProperties.width = $scope.textSelected.getWidth();
                            $scope.selectedTextProperties.height = $scope.textSelected.getHeight();
                            $scope.selectedTextProperties.rotation = $scope.textSelected.angle;
                            $scope.selectedTextProperties.fontPath = $scope.textSelected.fontPath;
                            $scope.selectedTextProperties.fontOption = $scope.textSelected.fontOption || 1;
                            $scope.selectedTextProperties.fontColorOption = $scope.textSelected.fontColorOption || 1;
                            $scope.selectedTextProperties.id = $scope.textSelected.id;
                            $scope.selectedTextProperties.skewX = $scope.textSelected.skewX;
                            $scope.selectedTextProperties.skewY = $scope.textSelected.skewY;
                            $scope.selectedTextProperties.outlineWidth = $scope.textSelected.getOutlineWidth();
                            $scope.selectedTextProperties.Itext = $scope.textSelected.Itext;
                            $scope.selectedTextProperties.locked = $scope.textSelected.locked;
                            $scope.selectedTextProperties.prefix = $scope.textSelected.prefix;
                            $scope.selectedTextProperties.suffix = $scope.textSelected.suffix;
                            $scope.selectedTextProperties.betweenCharacters = $scope.textSelected.betweenCharacters;
                            $scope.selectedTextProperties.betweenWords = $scope.textSelected.betweenWords;
                            $scope.selectedTextProperties.allowEdit = $scope.textSelected.allowEdit;
                            const flip = $scope.textSelected.getFlip();
                            $scope.selectedTextProperties.flipX = flip.flipX || false;
                            $scope.selectedTextProperties.flipY = flip.flipY || false;
                            $scope.selectedTextProperties.useAsMask = $scope.textSelected.useAsMask;
                            $scope.selectedTextProperties.useAsCutout = $scope.textSelected.useAsCutout;
                            $scope.selectedTextProperties.sourceElement = $scope.textSelected.sourceElement;

                            //update [0] to [selectedIndex]
                            if ($scope.textSelected.textures && $scope.textSelected.textures[0]) {
                                $scope.selectedTextProperties.texture = $scope.textSelected.textures[0].texturePath;
                                $scope.selectedTextProperties.textureScale =
                                    $scope.textSelected.textures[0].textureScale || 100;
                            } else {
                                $scope.selectedTextProperties.texture = 'null';
                            }

                            // Compute the new max and min font sizes according to the object size
                            let size = GeneralMathUtils.calculateFontSizesFromObject($scope.textSelected);
                            $scope.textSelected.setMinSizePx(size.min);
                            $scope.textSelected.setMaxSizePx(size.max);

                            if ($scope.textSelected.allowEdit && $scope.textSelected.originalInitCenterX != null) {
                                const values = GeneralMathUtils.calculateInitTextValuesFromObject($scope.textSelected);
                                $scope.textSelected.setInitPositionAndSize(
                                    values.initCenterX,
                                    values.initCenterY,
                                    values.initFontSize
                                );
                            }
                        }

                        loadTextData();

                        $scope.textSelected.on({
                            modified: function () {
                                loadTextData();
                                $timeout(function () {
                                    $scope.$apply();
                                });
                            }
                        });

                        if (
                            $scope.textSelected.id == $scope.getLastObjectId() &&
                            AppCuesService.getCurrentFlow() == AppCuesService.OptionBPart7
                        ) {
                            window.Appcues?.show(AppCuesService.OptionBPart8);
                        }
                    }
                    // Circular text selected
                    else if (activeObject.type === 'path-itext') {
                        $scope.textSelected = activeObject;
                        LibrariesUtilService.updateLibraryNames($scope, $scope.textSelected);

                        // eslint-disable-next-line no-inner-declarations
                        function loadCircularTextData() {
                            if (!$scope.textSelected) {
                                return;
                            }
                            // Load data
                            $scope.selectedTextProperties.text = $scope.textSelected.text;
                            $scope.selectedTextProperties.centerX = $scope.textSelected.left;
                            $scope.selectedTextProperties.centerY = $scope.textSelected.top;
                            $scope.selectedTextProperties.rotation = $scope.textSelected.angle;
                            $scope.selectedTextProperties.verticalDiameter = $scope.textSelected.verticalDiameter;
                            $scope.selectedTextProperties.horizontalDiameter = $scope.textSelected.horizontalDiameter;
                            $scope.selectedTextProperties.skewX = $scope.textSelected.skewX;
                            $scope.selectedTextProperties.skewY = $scope.textSelected.skewY;

                            $scope.selectedTextProperties.caps = $scope.textSelected.caps;
                            $scope.selectedTextProperties.fontPath = $scope.textSelected.fontPath;
                            $scope.selectedTextProperties.fontOption = $scope.textSelected.fontOption || 1;
                            $scope.selectedTextProperties.fontColorOption = $scope.textSelected.fontColorOption || 1;
                            $scope.selectedTextProperties.id = $scope.textSelected.id;
                            $scope.selectedTextProperties.outlineColor = $scope.textSelected.stroke;
                            $scope.selectedTextProperties.outlineWidth = $scope.textSelected.strokeWidth;
                            $scope.selectedTextProperties.locked = $scope.textSelected.locked;
                            $scope.selectedTextProperties.prefix = $scope.textSelected.prefix;
                            $scope.selectedTextProperties.suffix = $scope.textSelected.suffix;
                            $scope.selectedTextProperties.betweenCharacters = $scope.textSelected.betweenCharacters;
                            $scope.selectedTextProperties.betweenWords = $scope.textSelected.betweenWords;
                            const flip = $scope.textSelected.getFlip();
                            $scope.selectedTextProperties.flipX = flip.flipX || false;
                            $scope.selectedTextProperties.flipY = flip.flipY || false;

                            canvas.renderAll();

                            $scope.selectedTextProperties.fontSize = $scope.textSelected.fontSize;
                        }
                        loadCircularTextData();

                        $scope.textSelected.on({
                            modified: function () {
                                loadCircularTextData();
                                setTimeout(function () {
                                    $scope.$apply();
                                });
                            }
                        });
                    }
                    // Image placeholder or dynamic image selected
                    else if (activeObject.type === 'image-placeholder') {
                        $scope.imageSelected = activeObject;
                        LibrariesUtilService.updateLibraryNames($scope, $scope.imageSelected);

                        // eslint-disable-next-line no-inner-declarations
                        function loadImageData() {
                            if (!$scope.imageSelected) {
                                return;
                            }
                            // Load data
                            $scope.selectedImageProperties.centerX = $scope.imageSelected.left;
                            $scope.selectedImageProperties.centerY = $scope.imageSelected.top;
                            $scope.selectedImageProperties.rotation = $scope.imageSelected.angle;
                            $scope.selectedImageProperties.id = $scope.imageSelected.id;
                            $scope.selectedImageProperties.fullColor = $scope.imageSelected.fullColor;
                            $scope.selectedImageProperties.grading = $scope.imageSelected.grading;
                            $scope.selectedImageProperties.opacity = $scope.imageSelected.getOpacity();
                            $scope.selectedImageProperties.skewX = $scope.imageSelected.skewX;
                            $scope.selectedImageProperties.skewY = $scope.imageSelected.skewY;
                            $scope.selectedImageProperties.width = $scope.imageSelected.getWidth();
                            $scope.selectedImageProperties.height = $scope.imageSelected.getHeight();
                            $scope.selectedImageProperties.hasStaticImage = $scope.imageSelected.hasStaticImage;
                            $scope.selectedImageProperties.dynamicImagesPath = $scope.imageSelected.dynamicImagesPath;
                            $scope.selectedImageProperties.imageUrl = $scope.imageSelected.imageUrl;
                            $scope.selectedImageProperties.dynamicImageVariation =
                                $scope.imageSelected.dynamicImageVariation || 1;
                            $scope.selectedImageProperties.removeWhiteBackground =
                                $scope.imageSelected.removeWhiteBackground;
                            $scope.selectedImageProperties.CutoutFace = $scope.imageSelected.CutoutFace;
                            $scope.selectedImageProperties.removeBackgroundCOP =
                                $scope.imageSelected.removeBackgroundCOP;
                            $scope.selectedImageProperties.CustomilyRemoveBackground =
                                $scope.imageSelected.CustomilyRemoveBackground;
                            $scope.selectedImageProperties.CustomilyFaceCutOut =
                                $scope.imageSelected.CustomilyFaceCutOut;
                            $scope.selectedImageProperties.CustomilyImageFilter =
                                $scope.imageSelected.CustomilyImageFilter;
                            $scope.selectedImageProperties.isPencilDrawingActive =
                                $scope.imageSelected.CustomilyImageFilter === ImageFilter.PENCIL;
                            $scope.selectedImageProperties.isAquaFilterActive =
                                $scope.imageSelected.CustomilyImageFilter === ImageFilter.AQUA;
                            ($scope.selectedImageProperties.RemoveBackground = $scope.imageSelected.RemoveBackground),
                                ($scope.selectedImageProperties.locked = $scope.imageSelected.locked);
                            const flip = $scope.imageSelected.getFlip();
                            $scope.selectedImageProperties.CrosswordConfig = $scope.imageSelected.CrosswordConfig;
                            $scope.selectedImageProperties.crossword = $scope.imageSelected.crossword;
                            $scope.selectedImageProperties.calendarConfig = $scope.imageSelected.calendarConfig;
                            $scope.selectedImageProperties.imageToImageConfig = $scope.imageSelected.imageToImageConfig;
                            $scope.selectedImageProperties.imageToImage = $scope.imageSelected.imageToImage;
                            $scope.selectedImageProperties.imageEffects = $scope.imageSelected.imageEffects;
                            $scope.selectedImageProperties.calendar = $scope.imageSelected.calendar;
                            $scope.selectedImageProperties.flipX = flip.flipX || false;
                            $scope.selectedImageProperties.flipY = flip.flipY || false;
                            $scope.selectedImageProperties.initWidth = $scope.imageSelected.initWidth;
                            $scope.selectedImageProperties.initHeight = $scope.imageSelected.initHeight;
                            $scope.selectedImageProperties.initCenterX = $scope.imageSelected.initCenterX;
                            $scope.selectedImageProperties.initCenterY = $scope.imageSelected.initCenterY;
                            $scope.selectedImageProperties.initRotation = $scope.imageSelected.initRotation;
                            $scope.selectedImageProperties.limitMovement = $scope.imageSelected.limitMovement;
                            $scope.selectedImageProperties.hasTextMask = $scope.imageSelected.hasTextMask;

                            // Set image mode
                            if (!$scope.imageSelected.fullColor && !$scope.imageSelected.grading) {
                                $scope.selectedImageProperties.imageType = 'single color';
                            } else if (!$scope.imageSelected.fullColor && $scope.imageSelected.grading) {
                                $scope.selectedImageProperties.imageType = 'grading';
                            } else {
                                $scope.selectedImageProperties.imageType = 'full color';
                            }
                            $scope.selectedImageProperties.outlineWidth = $scope.imageSelected.outlineWidth;
                            $scope.selectedImageProperties.outlineColor = $scope.imageSelected.outlineColor;

                            $scope.imageColorPicker.setColor($scope.imageSelected.getColor());
                            if ($scope.imageSelected.outlineWidth > 0 && $scope.imageSelected.outlineColor) {
                                $scope.imageOutlineColorPicker.setColor($scope.imageSelected.outlineColor);
                            }
                            if (
                                !$scope.imageHasTextLink($scope.imageSelected) &&
                                $scope.selectedImageProperties.clipPath &&
                                $scope.imageSelected.clipPath
                            ) {
                                $scope.selectedImageProperties.clipPath.scaleX = $scope.imageSelected.clipPath.scaleX;
                                $scope.selectedImageProperties.clipPath.x = $scope.imageSelected.clipPath.left;
                                $scope.selectedImageProperties.clipPath.y = $scope.imageSelected.clipPath.top;
                            }
                        }
                        loadImageData();

                        if (
                            $scope.imageSelected.id == 3 &&
                            AppCuesService.getCurrentFlow() == AppCuesService.OptionBPart8
                        ) {
                            window.Appcues?.show(AppCuesService.OptionBPart9);
                        }

                        $scope.imageSelected.on({
                            modified: function () {
                                loadImageData();
                                $timeout(function () {
                                    $scope.$apply();
                                });
                            }
                        });
                    }
                    // Vector placeholder or dynamic vector selected
                    else if (activeObject.type === 'vector-placeholder') {
                        $scope.svgSelected = canvas.getActiveObject();
                        $scope.selectedSVGProperties.position = $scope.svgSelected.selectedPosition;
                        $scope.selectedSVGProperties.colorPosition = $scope.svgSelected.selectedColorPosition;
                        LibrariesUtilService.updateLibraryNames($scope, $scope.svgSelected);

                        // eslint-disable-next-line no-inner-declarations
                        function loadSVGGroupData() {
                            if (!$scope.svgSelected) {
                                return;
                            }
                            $scope.selectedSVGProperties.centerX = $scope.svgSelected.left;
                            $scope.selectedSVGProperties.centerY = $scope.svgSelected.top;
                            $scope.selectedSVGProperties.rotation = $scope.svgSelected.angle;
                            $scope.selectedSVGProperties.width = $scope.svgSelected.width * $scope.svgSelected.scaleX;
                            $scope.selectedSVGProperties.height = $scope.svgSelected.height * $scope.svgSelected.scaleY;
                            $scope.selectedSVGProperties.id = $scope.svgSelected.id;
                            $scope.selectedSVGProperties.allowUserUpload = $scope.svgSelected.allowUserUpload;
                            $scope.selectedSVGProperties.applyColoring = $scope.svgSelected.applyColoring;
                            $scope.selectedSVGProperties.isSolidBackground = $scope.svgSelected.isSolidBackground;
                            $scope.selectedSVGProperties.skewX = $scope.svgSelected.skewX;
                            $scope.selectedSVGProperties.skewY = $scope.svgSelected.skewY;
                            $scope.selectedSVGProperties.locked = $scope.svgSelected.locked;
                            const flip = $scope.svgSelected.getFlip();
                            $scope.selectedSVGProperties.flipX = flip.flipX || false;
                            $scope.selectedSVGProperties.flipY = flip.flipY || false;
                            $scope.selectedSVGProperties.allowEdit = $scope.svgSelected.allowEdit;
                            $scope.selectedSVGProperties.qrConfig = undefined;
                            $scope.selectedSVGProperties.allowSwapLibraryPosition =
                                $scope.svgSelected.allowSwapLibraryPosition;

                            // load qr
                            const qrConfig =
                                typeof $scope.svgSelected.qrConfig == 'string'
                                    ? JSON.parse($scope.svgSelected.qrConfig)
                                    : $scope.svgSelected.qrConfig;

                            if (qrConfig) {
                                $scope.selectedSVGProperties.qrConfig = { ...qrConfig };
                                $scope.svgSelected.qrConfig = { ...qrConfig };

                                if (!$scope.previewMode) {
                                    $timeout(() => {
                                        $scope.displayQrWithConfig(qrConfig, $scope.svgSelected);
                                    }, 300);
                                }
                            }
                        }
                        loadSVGGroupData();

                        $scope.svgSelected.on({
                            modified: function () {
                                loadSVGGroupData();
                                setTimeout(function () {
                                    $scope.$apply();
                                });
                            }
                        });
                    }

                    $timeout(function () {
                        $scope.$apply();
                    });
                }
            }

            // Focus the canvas container to be able to use keys right away
            if (canvas.eventContainer) {
                $('#' + canvas.eventContainer)[0].focus({
                    preventScroll: true
                });
            }
        };

        canvas.on({
            'object:scaling': function (e) {
                if (e && e.target && e.target.pattern) $scope.repositionPattern(e.target, true);
                if (canvas.getActiveObject() && canvas.getActiveObject().type == 'path-itext') {
                    $scope.textSelected = canvas.getActiveObject();

                    // Compute the scaled font size based on the size of the element
                    var fontSize = GeneralMathUtils.calculateCircularFontSizeFromDimensions(
                        $scope.textSelected.horizontalDiameter,
                        $scope.textSelected.originalHorizontalDiameter,
                        $scope.textSelected.originalFontSize
                    );

                    $scope.textSelected.set('fontSize', fontSize);

                    const { min, max } = GeneralMathUtils.calculateFontSizesFromDimensions(
                        $scope.textSelected.horizontalDiameter,
                        $scope.textSelected.originalHorizontalDiameter,
                        $scope.textSelected.originalMinSizePx,
                        $scope.textSelected.originalMaxSizePx
                    );
                    $scope.textSelected.set('minSizePx', min);
                    $scope.textSelected.set('maxSizePx', max);

                    $scope.selectedTextProperties.fontSize = $scope.textSelected.fontSize;
                    $scope.selectedTextProperties.minSizePx = $scope.textSelected.minSizePx;
                    $scope.selectedTextProperties.maxSizePx = $scope.textSelected.maxSizePx;
                }
            },
            'object:moving': function (e) {
                if (e && e.target && e.target.pattern) $scope.repositionPattern(e.target, false);
            },
            'object:rotating': function (e) {
                if (e && e.target && e.target.pattern) $scope.repositionPattern(e.target, false);
            },
            'object:added': function () {
                if ($scope.isUserDesignCreation && !$scope.previewMode) {
                    // If it is a design then select all elements, no matter if it is just one.
                    selectCanvasElements(canvas.getObjects(), canvas, true);
                }
            },
            'object:removed': function () {
                // Update the layers view when removing elements
            },
            /*'object:selected': function () {
                if ($scope.isUserDesignCreation && !$scope.previewMode) {
                    selectCanvasElements(canvas.getObjects(), canvas, true);
                }
            },*/
            'object:modified': function (e) {
                // Selection group was modified?
                const selection = canvas.getActiveObjects();
                if (selection.length > 1 && e.target.type === 'activeSelection') {
                    canvas.temporaryDiscardActiveObject(() => {
                        // Update elements sizes according to the current scaled that was applied
                        //  in the group selection
                        for (const element of selection) {
                            element.updateFromGroupScaling();

                            if (element.type === 'path-itext') {
                                // Compute the scaled font size based on the size of the element
                                const fontSize = GeneralMathUtils.calculateCircularFontSizeFromDimensions(
                                    element.horizontalDiameter,
                                    element.originalHorizontalDiameter,
                                    element.originalFontSize
                                );

                                const { min, max } = GeneralMathUtils.calculateFontSizesFromDimensions(
                                    element.horizontalDiameter,
                                    element.originalHorizontalDiameter,
                                    element.originalMinSizePx,
                                    element.originalMaxSizePx
                                );

                                element.set('fontSize', fontSize);
                                element.set('minSizePx', min);
                                element.set('maxSizePx', max);
                            } else if (element.type === 'bounded-text') {
                                // Compute the new max and min font sizes according to the object size
                                let size = GeneralMathUtils.calculateFontSizesFromObject(element);
                                element.setMinSizePx(size.min);
                                element.setMaxSizePx(size.max);

                                if (element.allowEdit && element.originalInitCenterX != null) {
                                    const values = GeneralMathUtils.calculateInitTextValuesFromObject(element);
                                    element.setInitPositionAndSize(
                                        values.initCenterX,
                                        values.initCenterY,
                                        values.initFontSize
                                    );
                                }
                            }

                            canvas.requestRenderAll();
                            element.updateFromGroupScaling();
                        }
                    });
                    canvas.requestRenderAll();
                }
                const activeObject = canvas.getActiveObject();
                // Ensure multiple selections always maintain uniform scaling to preserve proportions
                if (activeObject && activeObject.type === 'activeSelection') {
                    activeObject.set('lockUniScaling', true);
                    // Hide non-uniform scaling controls for multiple selections
                    activeObject.set('_controlsVisibility', {
                        ml: false, // middle left (scaleX)
                        mr: false, // middle right (scaleX)
                        mt: false, // middle top (scaleY)
                        mb: false, // middle bottom (scaleY)
                        tl: true, // top left (uniform scaling)
                        tr: true, // top right (uniform scaling)
                        bl: true, // bottom left (uniform scaling)
                        br: true // bottom right (uniform scaling)
                    });
                }
                if (e.target && e.target.type === 'bounded-text' && e.target.isPatternReplica && e.target.locked) {
                    $scope.relockPatternReplica(e.target);
                }
                // apply text mask
                canvas.fire('object:handle:textmask', { target: e.target });
            },
            'selection:created': (data) => {
                itemSelected(data);
            },
            'selection:updated': (data) => {
                itemSelected(data);
            },
            'selection:cleared': function () {
                $scope.textOutlineColorPicker.terminate();
                $scope.imageColorPicker.terminate();
                $scope.imageOutlineColorPicker.terminate();

                $scope.textSelected = null;
                $scope.imageSelected = null;
                $scope.svgSelected = null;
                $scope.hasSelectedElement = false;
                $scope.selectedSpotifyPlayer = null;

                if ($scope.selectedObjectGroup) {
                    canvas.off('object:modified', $scope.loadSelectedObjectGroupData);
                    canvas.off('customilyActiveSelection:modified');
                    $scope.selectedObjectGroup = null;
                }

                $timeout(function () {
                    $scope.$apply();
                });
            },
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            'mouse:up': function (event) {
                if (
                    $scope.isUserDesignCreation &&
                    canvas.getActiveObject() &&
                    canvas.getObjects() &&
                    canvas.getActiveObject().length !== 0 &&
                    canvas.getActiveObject().length !== canvas.getObjects().length &&
                    !$scope.previewMode
                ) {
                    selectCanvasElements(canvas.getObjects(), canvas, true);
                }
            },
            'mouse:down': function (event) {
                if ($scope.colorSamplerActive) {
                    ColorSamplerService.processColorSelection(event.e, function (colorPicker, type, object) {
                        let color = '#' + colorPicker.getColor('HEX');
                        if (type === 'fill') {
                            // Re-select the elements and set the colors
                            if (object.type === 'bounded-text' || object.type === 'path-itext') {
                                if (object.setColor) {
                                    object.setColor(color);
                                } else {
                                    object.set('fill', color);
                                }
                                MultipleFontService.saveFontColorToOption(
                                    colorPicker.getColors(),
                                    object,
                                    $scope.editMode
                                );
                                canvas.setActiveObject(object);
                            } else if (object.type === 'image-placeholder') {
                                cancelNextImageColorChangeDebounced = true;
                                $scope.imageColorSave(colorPicker.getColors(), object);
                            }
                        } else if (type === 'outline') {
                            if (object.type === 'bounded-text' || object.type === 'path-itext') {
                                // Save the outline color
                                if (object.type === 'bounded-text') {
                                    let color = colorPicker.getColor();
                                    object.outlineColor = MultipleFontService.createColorObj({
                                        hex: '#' + color.HEX,
                                        cmyk: `${color.cmyk.c},${color.cmyk.m},${color.cmyk.y},${color.cmyk.k}`
                                    });
                                }

                                if (object.setOutlineColor) {
                                    object.setOutlineColor(color);
                                    canvas.renderAll();
                                } else {
                                    object.set('stroke', color);
                                }
                                canvas.setActiveObject(object);
                            }
                        }
                        $scope.colorSamplerActive = false;
                    });
                }
            },
            'object:handle:textmask': async function (event) {
                if (!event?.target) return;
                const activeObject = event.target;
                const objects =
                    activeObject.type === 'activeSelection' ? activeObject.getObjects?.() || [] : [activeObject];
                const links = ProductService.getElementsLinks();
                for (const object of objects) {
                    if (object.type === 'bounded-text') {
                        if (object.pattern) $scope.repositionPattern(object, true);
                        else if (object.useAsMask) await $scope.applyTextMask(object.uuid);
                        else if (object.useAsCutout) await $scope.applyTextCutout(object.uuid);
                    } else if (object.type === 'image-placeholder') {
                        const link = links.find(
                            (l) =>
                                l.targetId === object.uuid &&
                                (l.valueFormat === ValueFormat.TextAsMask || l.valueFormat === ValueFormat.TextAsCutout)
                        );
                        if (link) {
                            if (link.valueFormat === ValueFormat.TextAsMask) await $scope.applyTextMask(link.sourceId);
                            else await $scope.applyTextCutout(link.sourceId);
                        }
                    }
                }
            },
            'before:transform': function () {
                const selection = canvas.getActiveObject();
                // Ensure multiple selections always maintain uniform scaling to preserve proportions
                if (selection && selection.type === 'activeSelection') {
                    selection.set('lockUniScaling', true);
                    // Hide non-uniform scaling controls for multiple selections
                    selection.set('_controlsVisibility', {
                        ml: false, // middle left (scaleX)
                        mr: false, // middle right (scaleX)
                        mt: false, // middle top (scaleY)
                        mb: false, // middle bottom (scaleY)
                        tl: true, // top left (uniform scaling)
                        tr: true, // top right (uniform scaling)
                        bl: true, // bottom left (uniform scaling)
                        br: true // bottom right (uniform scaling)
                    });
                }
            },
            'files:pasted': async function (event) {
                const { images, vectors } = event;
                const object = canvas.getActiveObject();
                const type = object ? $scope.getObjectType(object) : null;

                if (vectors.length && type == 'vector-placeholder') {
                    await $scope.displaySVGOnPlaceholder(vectors);
                }

                if (images.length) {
                    if (type == 'image-placeholder') {
                        await $scope.uploadImagesOnPlaceholder({ files: images });
                    } else {
                        if (!type?.length || type != 'dynamic-image') {
                            $scope.addDynamicImage();
                        }
                        $scope.imageSelected = canvas.getActiveObject();
                        $timeout(() => {
                            canvas.fire('images:pasted', images);
                        });
                    }
                }
            },
            'preview:list:updated': function (listPreview) {
                ProductService.setListPreview(listPreview);
            },
            'preview:added': async function (preview) {
                $scope.showBlockUiLoader(true, 'Creating preview...');
                const defaultPreview = ProductService.getDefaultPreview();

                await PreviewUtilService.saveStep2(
                    canvas,
                    $scope.isManagedUser,
                    $scope.editMode,
                    $scope.replacedBackground,
                    $scope.backgroundImageFile,
                    $scope.backgroundType
                );

                if (defaultPreview) {
                    canvas.editPreview(preview.PreviewId, {
                        imagePath: defaultPreview.imagePath,
                        bgColor: defaultPreview.bgColor,
                        width: defaultPreview.width,
                        height: defaultPreview.height
                    });
                }

                canvas.selectPreview(preview.PreviewId);
                $scope.showBlockUiLoader(false);
            },
            'preview:selected': async function (preview) {
                if (preview.PreviewId === ProductService._selectedPreview?.PreviewId) return;
                $scope.showBlockUiLoader(true, 'Loading preview...');
                $scope.loadPreview(false, preview);
            }
        });

        // Options for preview mode
        if ($scope.previewMode) {
            // Disabled group selection on preview mode
            canvas.selection = false;
            const preview = ProductService.getPreview();

            canvas.setArtworkSize(preview?.width, preview?.height);

            // Listen for events to update text elements
            $scope.$on('updateText:stepTwo', function (event, data) {
                // Look for the text with the same ID and set the same text
                const objects = canvas
                    .getObjects()
                    .filter(
                        (o) =>
                            o.id === data.id &&
                            (o.type === 'bounded-text' || o.type === 'path-itext' || o.type === 'text-transform')
                    );
                for (const object of objects) {
                    $scope.updateText(data.text, object);
                }
            });

            // Listen for events to update text font
            $scope.$on('updateTextFont:stepTwo', function (event, data) {
                // Look for the text with the same ID and set the same font
                const objects = canvas
                    .getObjects()
                    .filter(
                        (o) =>
                            o.id === data.id &&
                            (o.type === 'bounded-text' || o.type === 'path-itext' || o.type === 'text-transform')
                    );
                for (const object of objects) {
                    MultipleFontService.changeFontOption(object, data.fontOption, canvas);
                }
            });

            // Listen for events to update text font color
            $scope.$on('updateTextFontColor:stepTwo', function (event, data) {
                // Look for the text with the same ID and set the same font color
                const objects = canvas
                    .getObjects()
                    .filter(
                        (o) =>
                            o.id === data.id &&
                            (o.type === 'bounded-text' || o.type === 'path-itext' || o.type === 'text-transform')
                    );
                for (const object of objects) {
                    MultipleFontService.changeFontColorOption(null, object, data.fontColorOption, canvas);
                }
            });

            $scope.$on('updateDynamicImage:stepTwo', function (event, data) {
                const objects = canvas
                    .getObjects()
                    .filter((o) => o.id === data.id && o.type === 'image-placeholder' && o.dynamicImagesPath);
                for (const object of objects) {
                    object.dynamicImagesPath = data.dynamicImagesPath;
                    DynamicImageService.showDynamicImage(canvas, object, data.option);
                }
            });

            // Listen for events to update dynamic image/vector position
            $scope.$on('updateDynamicElementOption:stepTwo', function (event, data) {
                const objects = canvas
                    .getObjects()
                    .filter(
                        (o) =>
                            o.id === data.id &&
                            ((o.type === 'image-placeholder' && o.dynamicImagesPath) ||
                                (o.type === 'vector-placeholder' && !o.allowUserUpload))
                    );
                for (const object of objects) {
                    if (object.type === 'image-placeholder') {
                        DynamicImageService.showDynamicImage(canvas, object, data.option);
                    } else {
                        DynamicVectorService.changeDynamicEPSPosition(object, data.option, canvas);
                    }
                }
            });

            // Listen for events to upload images to image placeholders
            $scope.$on('uploadImagePlaceholder:stepTwo', async function (event, data) {
                const image = data.file;
                if (!image) return;

                if (
                    !$scope.selectedImageProperties.RemoveBackground &&
                    !$scope.selectedImageProperties.CutoutFace &&
                    !$scope.selectedImageProperties.removeBackgroundCOP &&
                    !$scope.selectedImageProperties.CustomilyRemoveBackground &&
                    !$scope.selectedImageProperties.CustomilyFaceCutOut &&
                    !$scope.selectedImageProperties.CustomilyImageFilter &&
                    !$scope.selectedImageProperties.imageEffects?.length
                ) {
                    TestImageService.previewImageOnPlaceholder(image, canvas, data.id);
                    return;
                }

                $scope.imageSelected.imageFile = image;

                if ($scope.selectedImageProperties.CutoutFace && $scope.apiKeys.cutoutPro)
                    await $scope.faceCutout(true);

                if ($scope.selectedImageProperties.removeBackgroundCOP && $scope.apiKeys.cutoutPro)
                    await $scope.faceCutout(false);

                // Remove background (remove.bg)
                if ($scope.selectedImageProperties.RemoveBackground && $scope.apiKeys.removeBg) await $scope.removeBg();

                if ($scope.selectedImageProperties.CustomilyRemoveBackground) await $scope.customilyRmbg();

                if ($scope.selectedImageProperties.CustomilyFaceCutOut) await $scope.CustomilyFaceCutOut();

                if ($scope.selectedImageProperties.CustomilyImageFilter)
                    await $scope.CustomilyImageFilter($scope.selectedImageProperties.CustomilyImageFilter);

                if ($scope.imageSelected.imageEffects?.length) {
                    try {
                        $scope.showBlockUiLoader(true, 'Transforming your image 📝✨🎨');
                        const sameIdObjects = canvas
                            .getObjects()
                            .filter((o) => o.type === 'image-placeholder' && o.id === $scope.imageSelected.id);
                        await ImageEffectsService.processImageEffects({
                            objects: sameIdObjects.length ? sameIdObjects : [$scope.imageSelected],
                            canvas,
                            username: $rootScope.user.Username,
                            file: $scope.imageSelected.imageFile
                        });
                    } catch (error) {
                        $mdDialog.show(
                            $mdDialog
                                .alert()
                                .parent(document.body)
                                .clickOutsideToClose(true)
                                .title('We received an error:')
                                .htmlContent(error.message)
                                .ok('OK!')
                        );
                    } finally {
                        $scope.showBlockUiLoader(false);
                        $timeout(() => $scope.$apply());
                    }
                }
            });

            // Listen for events to update image placeholder color
            $scope.$on('updateImageColorOption:stepTwo', function (event, data) {
                const objects = canvas
                    .getObjects()
                    .filter(
                        (o) =>
                            o.id === data.id &&
                            o.type === 'image-placeholder' &&
                            !o.dynamicImagesPath &&
                            !o.fullColor &&
                            !o.grading
                    );

                for (const object of objects) {
                    DynamicImageService.changeDynamicImageColorPosition(object, data.colorOption, null, canvas);
                }
            });

            $scope.$on('resetImageTestValue:stepTwo', async () => {
                const targetObject = canvas.getActiveObject();
                const object = canvas.getObjects().find((o) => o.uuid === targetObject.uuid);
                targetObject.testingUrl = '';
                TestImageService.showStaticImage(canvas, object, {
                    imageUrl: require('@/assets/images/photo-example.png')
                });
                if (!skipSaveTestingValues) {
                    $scope.IndexDbService.findAndEditValue(object.uuid, '');
                }
            });

            $scope.$on('resetSvgTestValue:stepTwo', async () => {
                const { selectedSVGProperties } = $scope;
                const targetObject = canvas.getActiveObject();
                const object = canvas
                    .getObjects()
                    .find((o) => o.uuid === targetObject.uuid && o.type === 'vector-placeholder');
                TestImageService.showStaticImageSvg(canvas, object, {
                    imageUrl: require('@/assets/images/vector-example.svg')
                });
                selectedSVGProperties.svgString = '';
                if (!skipSaveTestingValues) {
                    $scope.IndexDbService.findAndEditValue(object.uuid, '');
                }
            });

            // Listen for events to update dynamic vector color
            $scope.$on('updateVectorColorOption:stepTwo', function (event, data) {
                const objects = canvas
                    .getObjects()
                    .filter((o) => o.id === data.id && o.type === 'vector-placeholder' && o.applyColoring);

                for (const object of objects) {
                    DynamicVectorService.changeDynamicEPSColorPosition(object, data.colorOption, null, canvas);
                }
            });

            // Listen for events to upload vectors to vector placeholders
            $scope.$on('uploadVectorPlaceholder:stepTwo', async function (event, data) {
                if (data.file) {
                    const objects = canvas
                        .getObjects()
                        .filter((o) => o.id === data.id && o.type === 'vector-placeholder' && o.allowUserUpload);
                    for (const object of objects) {
                        await DynamicVectorService.loadFileOnPlaceholder(data.file, object, canvas);
                    }
                }
            });

            // Listen for requests for canvas preview image
            $scope.$on('canvas:previewImageRequest:stepTwo', async function (event, data) {
                let dataUrl = '';

                $scope.deselectAll();

                const targetSize = data.size || 100;
                const result = await ImageUtilService.limitImageResolution(canvas.toDataURL(), targetSize, targetSize);
                dataUrl = result.base64;

                $rootScope.$broadcast('canvas:previewImageGenerated:stepTwo', {
                    dataUrl: dataUrl
                });
            });

            $scope.$on('canvas:select:stepTwo', (event, data) => {
                if (data.uuids) {
                    const objects = canvas
                        .getObjects()
                        .filter((e) => data.uuids.includes(e.uuid) || data.uuids.includes(e.zIndex));
                    if (objects) {
                        // Select canvas elements and allow selecting single elements even if they are locked
                        selectCanvasElements(objects, canvas, true);
                    }
                }
            });

            $scope.$on('uploadCustomilyCalendar', function (event, date) {
                $scope.customilyCalendar.date = date;
                $scope.onCalendarDateChange();
            });

            $scope.$on('canvas:callback', function (_event, data) {
                const { callback } = data;
                if (callback) {
                    callback({
                        canvas
                    });
                }
            });

            $scope.$on('canvas:update-layers-order', function () {
                setTimeout(() => {
                    updateElementsOrderFromZIndex(canvas);
                });
            });

            $scope.$on('canvas:loaded:stepTwo', function () {
                if ($scope.layersInstance) {
                    $scope.layersInstance.$children[0].initGroupSelectionFromPageEps();
                }
            });

            // Listen for events to update Qr Codes
            $scope.$on('updateQrText:stepTwo', async function (event, data) {
                if (data.qrText) {
                    const objects = canvas
                        .getObjects()
                        .filter((o) => o.id === data.id && o.type === 'vector-placeholder' && o.qrConfig);
                    for (const object of objects) {
                        const qrConfig =
                            typeof object.qrConfig == 'string' ? JSON.parse(object.qrConfig) : object.qrConfig;

                        $scope.displayQrWithConfig(setQrData(qrConfig, data.qrText), object);
                    }
                }
            });

            $scope.$on('setActiveElement:stepTwo', function (event, data) {
                const object = canvas.getObjects().find((o) => o.id === data.id);
                canvas.setActiveObject(object);
            });
        }

        const objectHasProp = (object, property) => {
            return (
                Object.prototype.hasOwnProperty.call(object, property) &&
                object[property] !== null &&
                object[property] !== undefined
            );
        };

        $scope.getObjectType = (object) => {
            if (!object) return;

            const hasProp = {
                dynamicImagesPath: objectHasProp(object, 'dynamicImagesPath'),
                mapConfig: objectHasProp(object, 'mapConfig'),
                starMapConfig: objectHasProp(object, 'starMapConfig'),
                qrConfig: objectHasProp(object, 'qrConfig'),
                allowUserUpload: objectHasProp(object, 'allowUserUpload')
            };
            const objectType = object?.type;

            const isImagePlaceholder = objectType === 'image-placeholder';
            const isDynamicImage = isImagePlaceholder && hasProp.dynamicImagesPath;
            const isMap = isImagePlaceholder && hasProp.mapConfig;
            const isOverlay = isImagePlaceholder && hasProp.isColorOptions;
            const isProductColors = isImagePlaceholder && hasProp.isOverlay;
            const isVectorPlaceholder = objectType === 'vector-placeholder' && hasProp.allowUserUpload;
            const isDynamicVector = objectType === 'vector-placeholder' && !hasProp.allowUserUpload;
            const isStarMap = isVectorPlaceholder && hasProp.starMapConfig;

            if (isImagePlaceholder && !isDynamicImage && !isMap && !isStarMap) {
                return 'image-placeholder';
            } else if (isDynamicImage && !isMap && !isStarMap && !isOverlay && !isProductColors) {
                return 'dynamic-image';
            } else if (isVectorPlaceholder && !isDynamicVector && !isStarMap) {
                return 'vector-placeholder';
            }

            return null;
        };

        $scope.getCurrentElementTitle = function () {
            const object = canvas?.getActiveObject();
            return object ? getCanvasElementTitle(object) : '';
        };

        $scope.deleteSelectedElements = async function () {
            const deleted = await canvas.removeSelection();
            await cleanupDeletedTextEffects(canvas, deleted, ProductService, TEXT_EFFECT, removeTextEffect);
            $scope.cleanupDeletedPatterns(deleted);
        };

        $scope.onElementSelectedAlign = function (align) {
            const object = canvas.elementsSelectedAlign(align, $scope.elementAlignType, $scope.editMode);
            // apply text mask
            canvas.fire('object:handle:textmask', { target: object });
        };

        $scope.onElementAlignTypeChanged = function (alignType) {
            $scope.elementAlignType = alignType;
        };

        $scope.selectionToolbarEvents = {
            deleteSelection: () => {
                $scope.deleteSelectedElements();
                recordFeatureUsage(TrackedFeature.ToolbarDelete);
            },
            fitToCanvas: () => {
                $scope.onElementSelectedAlign('fit');
                recordFeatureUsage(TrackedFeature.ToolbarFitToCanvas);
            },
            fitToWidth: () => {
                $scope.onElementSelectedAlign('fit-width');
                recordFeatureUsage(TrackedFeature.FitWidth);
            },
            fitToHeight: () => {
                $scope.onElementSelectedAlign('fit-height');
                recordFeatureUsage(TrackedFeature.FitHeight);
            },
            alignTop: () => {
                $scope.onElementSelectedAlign('top');
                recordFeatureUsage(TrackedFeature.ToolbarAlignTop);
            },
            alignMiddle: () => {
                $scope.onElementSelectedAlign('middle');
                recordFeatureUsage(TrackedFeature.ToolbarAlignMiddle);
            },
            alignBottom: () => {
                $scope.onElementSelectedAlign('bottom');
                recordFeatureUsage(TrackedFeature.ToolbarAlignBottom);
            },
            alignLeft: () => {
                $scope.onElementSelectedAlign('left');
                recordFeatureUsage(TrackedFeature.ToolbarAlignLeft);
            },
            alignCenter: () => {
                $scope.onElementSelectedAlign('center');
                recordFeatureUsage(TrackedFeature.ToolbarAlignCenter);
            },
            alignRight: () => {
                $scope.onElementSelectedAlign('right');
                recordFeatureUsage(TrackedFeature.ToolbarAlignRight);
            }
        };

        $scope.addProductImageElement = (event) => {
            const addElement = () => {
                const productImages = PreviewUtilService.addProductColorElement(canvas, null, 'Product images');
                canvas.moveTo(productImages, productImages.zIndex);
                canvas.setActiveObject(productImages, event);
                const btn = document.getElementById('uploadImageFile');
                setTimeout(() => btn.click(), 10);
            };

            const productElement = canvas.getObjects().find((o) => o.isColorOptions);
            if (productElement) {
                $mdDialog
                    .show(
                        $mdDialog
                            .confirm()
                            .title('Alert')
                            .textContent(
                                'This product already has product images, creating a new product image will replace the existing one. Do you wish tio continue?'
                            )
                            .ok('Yes, Replace Images')
                            .cancel('Cancel')
                    )
                    .then(() => {
                        canvas.remove(productElement);
                        addElement();
                        setTimeout(() => {
                            updateElementsOrderFromZIndex(canvas);
                        });
                    });
                return;
            }

            addElement();
            setTimeout(() => {
                updateElementsOrderFromZIndex(canvas);
            });
        };

        $scope.addMask = () => {
            const mask = $scope.addDynamicImage();
            mask.set('isOverlay', true);
            mask.set('name', `Mask ${mask.id}`);
            mask.setEditedProp('isOverlay');
            mask.setEditedProp('name');
            setTimeout(() => {
                updateElementsOrderFromZIndex(canvas);
            });
            canvas.renderAll();
        };

        $scope.startBackgroundReplace = function () {
            // When replacing an existing background image we keep warning the user that
            //  using a very different size can push elements outside of the preview.
            if (ProductService.getPreviewImage() || $scope.backgroundImageFile) {
                $mdDialog
                    .show(
                        $mdDialog
                            .alert()
                            .parent(document.body)
                            .clickOutsideToClose(false)
                            .title('Background Image Replace')
                            .htmlContent(
                                'The background image should be replaced with another of a similar size. Using a very different size can result in elements going outside of the preview, if that’s the case, we recommend using the <b>Reset Preview</b> option.' +
                                    '<br /><br /> The current image size is <b>' +
                                    canvas.getArtworkWidth() +
                                    'x' +
                                    canvas.getArtworkHeight() +
                                    ' px</b>'
                            )
                            .ok('OK!')
                    )
                    .then(() => $scope.openReplaceBackgroundModal());
            } else {
                $scope.openReplaceBackgroundModal();
            }
        };

        $scope.openReplaceBackgroundModal = function () {
            // Open the same modal used for resetting the preview, but in 'replace' mode so
            //  only the background/size is swapped and the canvas elements are kept.
            $scope.previewBackgroundMode = 'replace';
            $scope.productPreviewBackground = {
                width: canvas.getArtworkWidth(),
                height: canvas.getArtworkHeight(),
                bgColor: ProductService.getPreviewBgColor() || undefined
            };
            $scope.showPreviewBackgroundModal = true;
        };

        $scope.step1HasStarMaps = function () {
            const vectorEPSEps = ProductService.getListEPS()
                .filter((eps) => eps.vectorEPSEps)
                .flatMap((eps) => eps.vectorEPSEps);

            const hasStarMapConfigVector = vectorEPSEps.some((vector) => vector.starMapConfig);
            return hasStarMapConfigVector;
        };

        $scope.setBackgroundColor = function (width, height, bgColor) {
            blockUI.start('Loading Data');

            // Reset the whole preview: clear elements, apply the new background and reload the product.
            canvas.clear();
            applyColorBackground(bgColor, width, height).then(async () => {
                if ($scope.step1HasStarMaps()) {
                    await starMapUtils.showCelestialContainer();
                }
                await delay(1000);
                await loadProduct(true);
                blockUI.stop();
                $timeout(() => $scope.$apply());
            });
        };

        $scope.handleResetLayerOpen = function () {
            $scope.showResetLayerModal = true;
        };

        $scope.loadPreview = async function (reloadEpsElements = false, preview = null) {
            // Save current preview changes
            await PreviewUtilService.saveStep2(
                canvas,
                $scope.isManagedUser,
                $scope.editMode,
                $scope.replacedBackground,
                $scope.backgroundImageFile,
                $scope.backgroundType
            );
            $scope.backgroundImageFile = null;
            $scope.replacedBackground = false;
            $scope.backgroundType = null;
            const current = preview || ProductService.getPreview();

            ProductService.setSelectedPreview(current);
            await loadPreviewBackground(reloadEpsElements);
        };

        $scope.handleResetLayer = async function (resetWholePreview = false) {
            if (resetWholePreview) {
                // Reset preview by asking to set background image or color again
                $scope.previewBackgroundMode = 'reset';
                $scope.showPreviewBackgroundModal = true;
                $scope.handleResetLayerClose();
                recordFeatureUsage(TrackedFeature.PreviewResetWhole);
                return;
            }
            $scope.showBlockUiLoader(true, 'Loading preview...');
            await $scope.loadPreview(true);

            // Save current preview changes for reseted elements
            await PreviewUtilService.saveStep2(
                canvas,
                $scope.isManagedUser,
                $scope.editMode,
                $scope.replacedBackground,
                $scope.backgroundImageFile,
                $scope.backgroundType
            );
            recordFeatureUsage(TrackedFeature.PreviewResetElements);
            $scope.handleResetLayerClose();
        };

        $scope.handleResetLayerClose = function () {
            $scope.showResetLayerModal = false;
        };

        $scope.loadCrosswordTextures = () => {
            if (!$scope.crosswordTextures.length) {
                CrosswordService.getAllTextures().then((textures) => {
                    textures.forEach((texture) => {
                        texture.Name = texture.Name.replace(/\.[^/.]+$/, '');
                        $scope.crosswordTextures.push(texture);
                    });
                });
            }
        };

        $scope.onCancelPreviewBackground = function () {
            $scope.showPreviewBackgroundModal = false;
        };

        $scope.onSetPreviewBackground = async function (background) {
            ProductService.setProductPreviewBackground(background);
            $scope.showPreviewBackgroundModal = false;
            $scope.productPreviewBackground = background;

            if ($scope.previewBackgroundMode === 'replace') {
                await $scope.replacePreviewBackground(background);
            } else if (background.imgFile) {
                await $scope.uploadImage([background.imgFile]);
            } else {
                $scope.setBackgroundColor(background.width, background.height, background.bgColor);
            }

            if (!$scope.previewMode) {
                $scope.setHeaderTitle();
            }
        };

        // Replace only the canvas background/size, keeping the existing elements.
        $scope.replacePreviewBackground = async function (background) {
            $scope.showBlockUiLoader(true, 'Loading...');
            try {
                if (background.imgFile) {
                    await applyImageBackground(background.imgFile);
                } else {
                    await applyColorBackground(background.bgColor, background.width, background.height);
                }
                $scope.applyTextMasks();
                canvas.renderAll();
                recordFeatureUsage(TrackedFeature.PreviewReplaceBackground);
            } catch (e) {
                console.error('Failed to replace preview background', e);
            } finally {
                $scope.showBlockUiLoader(false);
                $timeout(() => $scope.$apply());
            }
        };

        $scope.setHeaderTitle = function () {
            const title = `${ProductService.getProduct().name}: ${Number(canvas.getArtworkWidth()).toFixed(0)}x${Number(
                canvas.getArtworkHeight()
            ).toFixed(0)} px`;

            $rootScope.headerTitleLeft = title;
            $rootScope.headerMode = 'dual';
        };

        $scope.uploadImage = async function (files) {
            if (!files?.length) return;

            blockUI.start('Loading');
            $timeout(() => $scope.$apply());

            // Reset the whole preview: clear elements, apply the new background image and reload the product.
            canvas.clear();
            await applyImageBackground(files[0]);

            if ($scope.step1HasStarMaps()) {
                await starMapUtils.showCelestialContainer();
            }
            await loadProduct(true);
            blockUI.stop();
            $timeout(() => $scope.$apply());
        };

        const safeApply = () => {
            if ($scope.$applyAsync) $scope.$applyAsync();
            else $timeout(() => $scope.$apply());
        };

        const hideLoader = () => {
            $scope.showBlockUiLoader(false);
            safeApply();
            $scope.showBlockUiLoader(false);
        };

        const loadFabricImage = (url) =>
            new Promise((resolve, reject) => {
                try {
                    fabric.Image.fromURL(
                        url,
                        (img) => (img ? resolve(img) : reject(new Error('fabric returned no image'))),
                        { crossOrigin: 'anonymous' }
                    );
                } catch (e) {
                    reject(e);
                }
            });

        const setCanvasBackgroundImage = (img, options = { originX: 'left', originY: 'top' }) =>
            new Promise((resolve) => {
                canvas.setBackgroundImage(
                    img,
                    async () => {
                        // preserve previous behavior: allow async work inside callback
                        canvas.requestRenderAll();
                        resolve();
                    },
                    options
                );
            });

        const setCanvasBackgroundColorAsync = (color) =>
            new Promise((resolve) => {
                canvas.setBackgroundColor(color, () => {
                    canvas.requestRenderAll();
                    resolve();
                });
            });

        // Loads an image File and downscales it if it exceeds MAX_IMAGE_SIZE.
        // Returns the loaded image element and the (possibly resized) File.
        async function prepareBackgroundImageFile(imageFile) {
            let img = await loadImageFromBlob(imageFile, 'base64');

            if (img.width > $scope.MAX_IMAGE_SIZE || img.height > $scope.MAX_IMAGE_SIZE) {
                const { base64 } = await ImageUtilService.limitImageResolution(
                    img,
                    $scope.MAX_IMAGE_SIZE,
                    $scope.MAX_IMAGE_SIZE
                );
                img = await ImageUtilService.getImageFromSrc(base64);
                imageFile = new File([await imageToBlob(img)], imageFile.name);
            }

            return { img, imageFile };
        }

        // Applies an image File as the canvas background and adapts the artwork size to it.
        // Does not clear the canvas nor reload the product, so existing elements are kept.
        async function applyImageBackground(imageFile) {
            const { img, imageFile: resizedFile } = await prepareBackgroundImageFile(imageFile);

            canvas.setArtworkSize(img.width, img.height);
            $scope.backgroundImageFile = resizedFile;

            const bgImage = await loadFabricImage(img.src);
            bgImage.set({
                width: canvas.getArtworkWidth(),
                height: canvas.getArtworkHeight(),
                originX: 'left',
                originY: 'top'
            });

            await setCanvasBackgroundColorAsync('white');
            await setCanvasBackgroundImage(bgImage, { originX: 'left', originY: 'top' });

            ProductService.setPreviewBgColor(null);
            $scope.backgroundType = 'image';
            $scope.replacedBackground = true;
        }

        // Applies a color as the canvas background, optionally resizing the artwork.
        // Does not clear the canvas nor reload the product, so existing elements are kept.
        async function applyColorBackground(color, width, height) {
            if (width != null && height != null) {
                canvas.setArtworkSize(width, height);
            }

            $scope.backgroundImageFile = null;
            $scope.backgroundType = 'color';
            $scope.replacedBackground = true;
            ProductService.setPreviewImage(null);
            ProductService.setPreviewBgColor(color);

            await setCanvasBackgroundColorAsync(color);
        }

        async function loadWholePreviewBackground() {
            const productPreviewBackground = ProductService.getProductPreviewBackground();
            if (!productPreviewBackground) return;
            $scope.onSetPreviewBackground(productPreviewBackground);
        }

        async function loadPreviewBackground(resetEpsElements = false) {
            try {
                const preview = ProductService.getPreview();
                const hasImage = !!ProductService.getPreviewImage();
                const hasColor = !!ProductService.getPreviewBgColor();

                if (hasImage || hasColor) {
                    $scope.showBlockUiLoader(true, 'Loading Data');

                    canvas.clear();
                    canvas.setArtworkSize(preview?.width, preview?.height);

                    if (hasImage) {
                        // --- Background image flow ---
                        $scope.backgroundType = 'image';

                        const imageUrl = buildCloudFrontUrl(ProductService.getPreviewImage());

                        // temporary background while image loads
                        await setCanvasBackgroundColorAsync('white');

                        try {
                            const backgroundImage = await loadFabricImage(imageUrl);
                            backgroundImage.set({ originX: 'left', originY: 'top' });
                            backgroundImage.scaleToWidth(canvas.getArtworkWidth());

                            // Wait until fabric has set the background image
                            await setCanvasBackgroundImage(backgroundImage, { originX: 'left', originY: 'top' });

                            if ($scope.step1HasStarMaps()) {
                                await starMapUtils.showCelestialContainer();
                            }

                            await loadProduct(resetEpsElements, true);
                        } catch (e) {
                            console.error('Failed to load background image', e);
                        } finally {
                            hideLoader();
                        }
                    } else {
                        // --- Background color flow ---
                        $scope.backgroundType = 'color';

                        try {
                            await setCanvasBackgroundColorAsync(ProductService.getPreviewBgColor());

                            if ($scope.step1HasStarMaps()) {
                                await starMapUtils.showCelestialContainer();
                            }

                            await loadProduct(resetEpsElements, true);

                            if ($scope.layersInstance) {
                                $scope.layersInstance.$children[0].singleGroupSelection();
                                $scope.deselectAll();
                            }

                            $scope.applyTextMasks();
                        } catch (e) {
                            console.error('Failed to set background color', e);
                        } finally {
                            hideLoader();
                        }
                    }
                    $scope.setHeaderTitle();
                } else if ($scope.forProductTemplateCreation && ProductService.getProductTemplatePreviewTargetSize()) {
                    const { width, height } = ProductService.getProductTemplatePreviewTargetSize();
                    $scope.setBackgroundColor(width, height, 'rgba(255, 255, 255, 1)');
                    $scope.setHeaderTitle();
                    hideLoader();
                } else {
                    hideLoader();
                    loadWholePreviewBackground();
                }
            } catch (err) {
                console.error('Error in loadPreviewBackground', err);
                hideLoader();
            }
        }

        loadPreviewBackground();

        function synchronizeProperties(elements, epsElements, properties) {
            if (!elements.length || !epsElements.length) {
                return;
            }

            for (const element of elements) {
                const epsElement = epsElements.find((e) => e.uuid === element.uuid);
                if (!epsElement) {
                    continue;
                }

                for (const prop of properties) {
                    element[prop] = epsElement[prop];
                }
            }
            $scope.$applyAsync();
        }

        function checkEditMode() {
            const preview = ProductService.getPreview();

            $scope.editMode =
                preview?.textsPreview?.length > 0 ||
                preview?.imagePlaceHoldersPreview?.length > 0 ||
                preview?.circularTextsPreview?.length > 0 ||
                preview?.vectorEPSPreview?.length > 0;
        }

        function loadProduct(forceReload = false, keepPreviewElements = false) {
            // eslint-disable-next-line no-async-promise-executor
            return new Promise(async (resolve, reject) => {
                try {
                    const preview = ProductService.getPreview();
                    checkEditMode();
                    $scope.fonts = fontManagerService.loadedFonts;

                    const listEPS = ProductService.getListEPS();
                    const imagePlaceHoldersEpsList = listEPS.map((s) => s.imagePlaceHoldersEps).flat();
                    const textsEpsList = listEPS.map((s) => s.textsEps).flat();
                    const circularTextsEpsList = listEPS.map((s) => s.circularTextsEps).flat();
                    const vectorEPSEpsList = listEPS.map((s) => s.vectorEPSEps).flat();

                    const imagePlaceHolders =
                        !forceReload && ($scope.previewMode || $scope.editMode)
                            ? preview.imagePlaceHoldersPreview
                            : cloneDeep(imagePlaceHoldersEpsList);

                    let previewElementIds = new Set();
                    if (keepPreviewElements && forceReload) {
                        const previewElements = ProductService.getPreviewOnlyElements(preview.imagePlaceHoldersPreview);
                        previewElementIds = new Set(previewElements.map((e) => e.uuid));
                        imagePlaceHolders.push(...previewElements);
                    }

                    if (imagePlaceHolders.some((i) => i.CrosswordConfig != null)) {
                        $scope.loadCrosswordTextures();
                    }

                    /**
                     * If we are editing a template and change the test image on a image placeholder on step1
                     * we insert the new test image to the preview element so it changes there too. Only applies
                     * when reusing the existing preview (not the first time / not a forced reload).
                     */
                    if (!forceReload && ($scope.previewMode || $scope.editMode)) {
                        const epsMap = new Map(imagePlaceHoldersEpsList.map((image) => [image.uuid, image]));
                        for (const imagePlaceHolder of imagePlaceHolders) {
                            const epsPlaceholder = epsMap.get(imagePlaceHolder.uuid);
                            if (!epsPlaceholder) continue;
                            if (
                                !imagePlaceHolder.dynamicImagesPath &&
                                !imagePlaceHolder.mapConfig &&
                                !imagePlaceHolder.calendar
                            ) {
                                imagePlaceHolder.testingUrl = epsPlaceholder.testingUrl;
                            }
                            if (epsPlaceholder.wordCloudConfig) {
                                imagePlaceHolder.wordCloudConfig = epsPlaceholder.wordCloudConfig;
                            }
                        }
                    }

                    console.log(`Artwork size is ${canvas.getArtworkWidth()}x${canvas.getArtworkHeight()}px`);

                    // Load all the elements into the canvas
                    const comesFromStep1 = $rootScope?.lastLocation?.includes('/createProduct1') || false;
                    const { loadFromStep1 } = resolveStep2LoadDecision({
                        forceReload,
                        previewMode: $scope.previewMode,
                        editMode: $scope.editMode,
                        comesFromStep1
                    });
                    const previewToLoad = !loadFromStep1 ? ProductService.getPreview() : preview;
                    const texts = !loadFromStep1 ? previewToLoad.textsPreview : textsEpsList;
                    const circularTexts = !loadFromStep1 ? previewToLoad.circularTextsPreview : circularTextsEpsList;
                    const vectorsEps = !loadFromStep1 ? previewToLoad.vectorEPSPreview : vectorEPSEpsList;
                    const allGroups = ProductService.getGroups();
                    const groupsEps = allGroups.filter((g) => g.type === 'eps');
                    const groupsPreview = allGroups.filter((g) => g.type === 'preview');
                    const groups = !loadFromStep1
                        ? groupsPreview
                        : keepPreviewElements && forceReload
                        ? [...groupsEps, ...groupsPreview]
                        : groupsEps;

                    const childTemplateProduct = ProductService.getChildTemplateProduct();
                    const isChildTemplateProduct = !!childTemplateProduct?.parentId;
                    $scope.hideMultiPreviewActions = isChildTemplateProduct;

                    if (!$scope.hideMultiPreviewActions) {
                        const templateProduct = ProductService.getProduct();
                        $scope.hideMultiPreviewActions = (templateProduct?.templateProductVariants || []).some((v) =>
                            v.name.includes(isPrintSizeVariant)
                        );
                    }

                    $scope.isParentOrChildTemplateProduct = $scope.hideMultiPreviewActions;

                    if (!loadFromStep1) {
                        $scope.$applyAsync();
                        synchronizeProperties(
                            [...(circularTexts ?? []), ...(texts ?? [])],
                            [...(circularTextsEpsList ?? []), ...(textsEpsList ?? [])],
                            ['fontsMap']
                        );
                    }

                    await PreviewUtilService.loadStep2IntoCanvas(
                        canvas,
                        $scope.fonts,
                        $scope.previewMode,
                        $rootScope.user.Username,
                        texts,
                        circularTexts,
                        imagePlaceHolders,
                        vectorsEps,
                        loadFromStep1,
                        ProductService.getNeedColorsUpgrade(),
                        $scope.forProductTemplateCreation,
                        ProductService.getPreviewColorOptionsMetadata(),
                        groups,
                        $scope.forMyProductBases,
                        isChildTemplateProduct,
                        listEPS,
                        groupsEps,
                        comesFromStep1,
                        $scope.editMode,
                        previewElementIds
                    );

                    // Set default layout visibility synchronously before yielding
                    // to the browser, so the canvas never renders with all layouts
                    // visible (flash). initGroupSelectionFromPageEps will run later
                    // to sync the layer panel UI.
                    const mgr = getGroupManager();
                    if (mgr) {
                        const defaults = mgr.getDefaultVisibleLayouts();
                        if (defaults.length > 0) {
                            mgr.setVisibility(defaults, true);
                        }
                    }

                    $scope.deselectAll();
                    if ($scope.undoManager) $scope.undoManager.clear();
                    $timeout(() => {
                        $scope.$apply();
                        if ($scope.layersInstance) {
                            $scope.layersInstance.$children[0].initGroupSelectionFromPageEps();
                        }
                        $rootScope.$broadcast('canvas:loaded:stepThree');

                        const colorOptionsImg = canvas.getObjects().find((o) => o.isColorOptions && o.imageLibraryId);
                        if (colorOptionsImg) {
                            canvas.setActiveObject(colorOptionsImg);
                            canvas.renderAll();
                        }
                    });

                    // apply text masks
                    await $scope.applyTextMasks();

                    const listPreview = ProductService.getListPreview();
                    canvas?.setListPreview(listPreview);
                    canvas?.selectPreview(preview.PreviewId, true);
                    resolve();
                } catch (error) {
                    console.error(error);
                    reject(error);
                }
            });
        }

        $scope.template = ProductService.getProduct();

        $scope.deselectAll = function () {
            canvas.discardActiveObject().renderAll();
            $scope.textSelected = null;
            $scope.imageSelected = null;
        };

        $scope.showResizedAlert = async function () {
            await $mdDialog.show(
                $mdDialog
                    .alert()
                    .parent(document.body)
                    .clickOutsideToClose(false)
                    .title('Large Images')
                    .htmlContent(
                        `At least one image has a size bigger than <b>${$scope.MAX_IMAGE_SIZE} px</b> which can result in bad performance and slow loading times on your store! It will be scaled down!`
                    )
                    .ok('OK!')
            );
        };

        $scope.uploadImagesOnPlaceholder = async function (fileObject, isPlaceholder) {
            const files = [];
            let hasResizedImages = false;

            if (!isPlaceholder) {
                // Make sure all the images are below the max image size
                for (const file of fileObject.files) {
                    const result = await ImageUtilService.limitImageResolutionFromFile(
                        file,
                        $scope.MAX_IMAGE_SIZE,
                        $scope.MAX_IMAGE_SIZE
                    );
                    hasResizedImages = hasResizedImages || result.resized;
                    files.push(result.file);
                }
            } else {
                files.push(fileObject.files[0]);
            }

            $scope.imageSelected.imageFile = files[0];

            const object = canvas.getActiveObject();
            let firstStepPlaceholder;
            if (isPlaceholder) {
                const firstStepElements = ProductService.getEps(object.pageEpsId);
                firstStepPlaceholder = firstStepElements.imagePlaceHoldersEps.find(
                    (imagePlaceholderObject) => imagePlaceholderObject.uuid === object.uuid
                );
            }
            if ($scope.imageSelected.dynamicImagesPath) {
                $scope.imageSelected = null;
            }

            await MultipleFileUploadService.uploadMultipleImages(
                $scope,
                canvas,
                files,
                object,
                true,
                isPlaceholder,
                firstStepPlaceholder
            );

            if ($scope.selectedImageProperties.CutoutFace && $scope.apiKeys.cutoutPro) await $scope.faceCutout(true);

            if ($scope.selectedImageProperties.removeBackgroundCOP && $scope.apiKeys.cutoutPro)
                await $scope.faceCutout(false);

            if ($scope.selectedImageProperties.RemoveBackground && $scope.apiKeys.removeBg) await $scope.removeBg();

            if ($scope.selectedImageProperties.CustomilyRemoveBackground) await $scope.customilyRmbg();

            if ($scope.selectedImageProperties.CustomilyFaceCutOut) await $scope.CustomilyFaceCutOut();

            if ($scope.selectedImageProperties.CustomilyImageFilter)
                await $scope.CustomilyImageFilter($scope.imageSelected.CustomilyImageFilter);

            if (object.imageEffects?.length) {
                try {
                    $scope.showBlockUiLoader(true, 'Transforming your image 📝✨🎨');
                    const sameIdObjects = canvas
                        .getObjects()
                        .filter((o) => o.type === 'image-placeholder' && o.id === object.id);
                    await ImageEffectsService.processImageEffects({
                        objects: sameIdObjects.length ? sameIdObjects : [object],
                        canvas,
                        username: $rootScope.user.Username,
                        file: $scope.imageSelected.imageFile
                    });
                } catch (error) {
                    $mdDialog.show(
                        $mdDialog
                            .alert()
                            .parent(document.body)
                            .clickOutsideToClose(true)
                            .title('We received an error:')
                            .htmlContent(error.message)
                            .ok('OK!')
                    );
                } finally {
                    $scope.showBlockUiLoader(false);
                }
            }

            fileObject.value = null;

            // process text mask
            TextService.processTextMask(canvas, $scope, [$scope.selectedImageProperties]);

            $timeout(() => {
                $scope.imageSelected = object;
                $scope.$apply();
            });
        };

        $scope.isTextToImagePromptActive = false;
        $scope.setIsTextToImagePromptActive = function (value) {
            $scope.isTextToImagePromptActive = value;
        };

        $scope.generateTextToImageTest = function (promptText) {
            if (!promptText || !$scope.imageSelected) return;

            const data = { ids: [$scope.imageSelected.id], prompt: promptText };

            $rootScope.$broadcast('generateTextToImageTest:stepOne', data);
            $rootScope.$broadcast('generateTextToImageTest:stepTwo', data);
        };

        $scope.$on('generateTextToImageTest:stepTwo', async (_, data) => {
            if (!data?.ids?.length || !data?.prompt) return;

            const sameIdObjects = canvas
                .getObjects()
                .filter((o) => o.type === 'image-placeholder' && data.ids.includes(o.id));

            if (!sameIdObjects.length) return;

            try {
                $scope.showBlockUiLoader(true, 'Generating your image 📝✨🎨');
                await ImageEffectsService.processImageEffectsFromPrompt({
                    objects: sameIdObjects,
                    canvas,
                    username: $rootScope.user.Username,
                    prompt: data.prompt
                });
            } catch (error) {
                $mdDialog.show(
                    $mdDialog
                        .alert()
                        .parent(document.body)
                        .clickOutsideToClose(true)
                        .title('We received an error:')
                        .htmlContent(error.message)
                        .ok('OK!')
                );
            } finally {
                $scope.showBlockUiLoader(false);
                $timeout(() => $scope.$apply());
            }
        });

        $scope.resetImageTestValue = async function () {
            const targetObject = canvas.getActiveObject();
            const object = canvas.getObjects().find((o) => o.uuid === targetObject.uuid);
            targetObject.testingUrl = '';
            TestImageService.showStaticImage(canvas, object, {
                imageUrl: require('@/assets/images/photo-example.png')
            });

            const product = ProductService.getProduct();
            const stepOneImagePlaceholders = product.listEPS.map((eps) => eps.imagePlaceHoldersEps).flat();
            const targetStepOneObject = stepOneImagePlaceholders.find((sOneImgPh) => sOneImgPh.uuid === object.uuid);
            if (targetStepOneObject) targetStepOneObject.testingUrl = '';
            if (!skipSaveTestingValues) {
                $scope.IndexDbService.findAndEditValue(object.uuid, '');
            }
        };

        $scope.trustedTestSvg = '';

        $scope.resetSvgTestValue = async function () {
            const { selectedSVGProperties } = $scope;
            const targetObject = canvas.getActiveObject();
            const object = canvas
                .getObjects()
                .find((o) => o.uuid === targetObject.uuid && o.type === 'vector-placeholder');
            TestImageService.showStaticImageSvg(canvas, object, {
                imageUrl: require('@/assets/images/vector-example.svg')
            });
            selectedSVGProperties.svgString = '';
            $scope.trustedTestSvg = '';

            const product = ProductService.getProduct();
            const stepOneVectorPlaceholders = product.listEPS.map((eps) => eps.vectorEPSEps).flat();
            const targetStepOneObject = stepOneVectorPlaceholders.find(
                (sOneVectorPh) => sOneVectorPh.uuid === object.uuid
            );
            if (targetStepOneObject) targetStepOneObject.svgString = '';
            if (!skipSaveTestingValues) {
                $scope.IndexDbService.findAndEditValue(object.uuid, '');
            }
        };

        $scope.$watch('svgSelected.svgString', function (newVal) {
            if (newVal && !/^<!--\s*default customily vector\s*-->/.test(newVal.trim())) {
                $scope.trustedTestSvg = $sce.trustAsResourceUrl(
                    'data:image/svg+xml;utf8,' + encodeURIComponent(newVal)
                );
            } else {
                $scope.trustedTestSvg = '';
            }
        });

        $scope.addDynamicImage = function (event) {
            const image = DynamicImageService.createDynamicImage(canvas, $scope.getLastObjectId() + 1, {
                pageEpsId: null,
                addedOnEdit: $scope.editMode,
                zIndex: canvas.getHighestZIndex() + 1
            });

            canvas.add(image);
            canvas.setActiveObject(image, event);

            setTimeout(() => {
                updateElementsOrderFromZIndex(canvas);
            });

            return image;
        };

        /**
         * This method transforms the given Vector EPS object to a dynamic image and asks the user to upload
         *  and image to use
         * @param {Object} svgObject Vector EPS object to transform
         */
        $scope.convertVectorEPSOverlay = function (svgObject, event) {
            svgObject ||= $scope.svgSelected;

            // Add a dynamic image
            const addedImage = $scope.addDynamicImage();

            // Replace the ID and UUID of the added image with the ID of the Vector EPS
            addedImage.set('id', svgObject.id);
            addedImage.set('uuid', svgObject.uuid);
            addedImage.set('pageEpsId', svgObject.pageEpsId);
            addedImage.set('groupId', svgObject.groupId);
            addedImage.set('zIndex', svgObject.zIndex);
            canvas.requestRenderAll();

            // Remove the Vector EPS
            setTimeout(() => {
                canvas.remove(svgObject);
                canvas.requestRenderAll();

                // Deselect and re-select the object to update the properties
                canvas.discardActiveObject();
                canvas.setActiveObject(addedImage, event);

                // Trigger the image upload button for the added dynamic image
                $("form[name='imageForm'] [input-id='inputFileTest']").click();
            }, 200);
        };

        $scope.changeFontOption = function () {
            MultipleFontService.changeFontOptionPreview(
                canvas.getActiveObject(),
                $scope.selectedTextProperties.fontOption,
                canvas
            );
        };

        $scope.changeFontTexture = function (texturePath, textSelected) {
            const object = textSelected || canvas.getActiveObject();
            if (!texturePath || texturePath === 'null') {
                texturePath = null;
            }
            // dirty way to make vue detect the change on text selected variable
            $scope.textSelected = { ...object };
            TextureService.changeFontTexture(texturePath, object, 1).then(() => {
                $scope.$apply(() => {
                    $scope.textSelected = object;
                });
                if (object?.pattern) {
                    for (const replica of TextService.getPatternReplicaObjects(canvas, object.uuid)) {
                        replica.texture = object.texture;
                        replica.textures = object.textures;
                        TextureService.changeFontTexture(texturePath, replica, 1);
                    }
                }
                canvas.renderAll();
            });
        };

        $scope.changeTextureScale = function (textureScale, textSelected) {
            TextureService.changeScaleTexture(textSelected, 1, textureScale || 100).then(() => {
                if (textSelected?.pattern) {
                    for (const replica of TextService.getPatternReplicaObjects(canvas, textSelected.uuid)) {
                        replica.textureScale = textSelected.textureScale;
                        TextureService.changeScaleTexture(replica, 1, textureScale || 100);
                    }
                }
                canvas.renderAll();
            });
        };

        $scope.changeDynamicImageColorPosition = function () {
            DynamicImageService.changeDynamicImageColorPosition(
                canvas.getActiveObject(),
                $scope.selectedImageProperties.colorPosition,
                $scope.imageColorPicker,
                canvas
            );
        };

        $scope.removeBg = async function () {
            // This method does not update oldImage since the control to swap it does not exist.
            blockUI.start('Removing background');
            try {
                const response = await RemoveBgAPIService.removeBackground(
                    $scope.apiKeys.removeBg,
                    $scope.imageSelected.imageFile
                );
                $scope.imageSelected.imageFile = response;
                await MultipleFileUploadService.uploadMultipleImages($scope, canvas, [response]);
            } catch (error) {
                window.rumReportError(error);
                $timeout(() => $scope.$apply());
                $mdDialog.show(
                    $mdDialog
                        .alert()
                        .parent(document.body)
                        .clickOutsideToClose(true)
                        .title('Remove.bg Error: ' + error.statusText)
                        .textContent(
                            'Configuration is saved! But image without background it is not shown in the placeholder'
                        )
                        .ok('OK!')
                );
            } finally {
                blockUI.stop();
            }
        };

        $scope.faceCutout = async function (cutFace) {
            await CutoutProUtilService.faceCutout($scope, canvas, cutFace, true);
        };

        $scope.customilyRmbg = async function () {
            await CustomilyRmbgService.applyFilter(undefined, $scope, canvas);
        };

        $scope.CustomilyFaceCutOut = async function () {
            await CustomilyFaceCutOutService.applyFilter(undefined, $scope, canvas);
        };

        $scope.templateProductColorHasDynamicImages = () => {
            const preview = ProductService.getPreview();
            const productColorsElement = preview?.imagePlaceHoldersPreview.find((i) => i.isColorOptions);
            //here we are validating if the user is uploading at least one image in the product colors imagePlaceHolder
            if (
                productColorsElement &&
                (JSON.parse(productColorsElement.dynamicImagesPath).length || productColorsElement.imageLibraryId)
            )
                return true;

            const dialog = $scope.forMyProductBases
                ? {
                      title: 'Alert',
                      msg:
                          'We can’t find any produt images. Please make sure you upload your product images before moving forward'
                  }
                : {
                      title: `Please upload image on ${productColorsElement.name}`,
                      msg: 'Upload at least 1 image'
                  };

            $mdDialog.show(
                $mdDialog
                    .alert()
                    .parent(document.body)
                    .clickOutsideToClose(true)
                    .title(dialog.title)
                    .textContent(dialog.msg)
                    .ok('OK!')
            );
            return false;
        };

        $scope.CustomilyImageFilter = async function (filter) {
            await CustomilyImageFilterService.applyFilter(undefined, filter, $scope, canvas);
        };

        $scope.goToStep3 = async function () {
            // Save all the data
            blockUI.start('Saving data');

            // finally, not a plain call after the await: a rejection here used to leave the block
            // counter up for good, freezing the overlay and anything gated on it.
            try {
                await PreviewUtilService.saveStep2(
                    canvas,
                    $scope.isManagedUser,
                    $scope.editMode,
                    $scope.replacedBackground,
                    $scope.backgroundImageFile,
                    $scope.backgroundType
                );
            } finally {
                blockUI.stop();
            }

            if ($scope.forProductTemplateCreation) {
                if (!$scope.templateProductColorHasDynamicImages()) return;
            }

            if ($scope.fromListing) {
                $location.path('/createProduct3').search({
                    fromListing: 'true',
                    fromPreview: 'true',
                    forProductTemplateCreation: 'true',
                    forMyProductBases: 'true'
                });
            } else if ($scope.isUserDesignCreation) {
                $location.path('/createProduct3').search({
                    forUserDesignCreation: 'true',
                    flowId: $location.search().flowId
                });
            } else {
                $location.path('/createProduct3');
            }
            $timeout(() => $scope.$apply());
        };

        $scope.displaySVGOnPlaceholder = async function (files) {
            if (files && files[0]) {
                const objects = canvas
                    .getObjects()
                    .filter(
                        (o) =>
                            o.id === canvas.getActiveObject().id && o.type === 'vector-placeholder' && o.allowUserUpload
                    );
                for (const object of objects) {
                    const firstStepElements = ProductService.getEps(object.pageEpsId);
                    const firstStepPlaceholder = firstStepElements.vectorEPSEps.find(
                        (vectorPlaceholderObject) => vectorPlaceholderObject.uuid === object.uuid
                    );
                    await DynamicVectorService.loadFileOnPlaceholder(
                        files[0],
                        object,
                        canvas,
                        true,
                        firstStepPlaceholder
                    );
                }
                $timeout(() => $scope.$apply());
            }
        };

        $scope.displayStringSVG = function (svgString, object, canvas) {
            if (!svgString.length) return;
            const contentLoadPromise = DynamicVectorService.loadSVGStringOnPlaceholder(svgString, object, canvas);
            $timeout(() => $scope.$apply());
            return contentLoadPromise;
        };

        $scope.updateQrText = async function (newText) {
            if ($scope.svgSelected) {
                const newConfig = setQrData($scope.svgSelected.qrConfig, newText);
                await $scope.displayQrWithConfig(newConfig, $scope.svgSelected);
            }
        };

        $scope.displayQrWithConfig = async (config = {}, object) => {
            var mutex = ProductService.getQrMutex();
            const content = await QrUtilService.getQrSvg(config, mutex);
            await $scope.displayStringSVG(content, object, canvas);
        };

        /****************************************************************************/
        /****************************** PARAMETERS UPDATE ***************************/
        /****************************************************************************/
        $scope.updateText = function (text, object) {
            TextService.updateTexts(text, object, canvas);
            if (!skipSaveTestingValues) {
                $scope.IndexDbService.findAndEditValue(object.uuid, text);
            }

            $scope.selectedTextProperties.currentFontSize = fabric.util.pxToPt(
                object.getFontSize && object.getFontSize()
            );
            $scope.selectedTextProperties.text = object.getText ? object.getText() : object.text;

            // apply text mask
            canvas.fire('object:handle:textmask', { target: object });
        };

        $scope.updateMinSizePx = function (size = 0, object) {
            object.setMinSizePx(size);
            canvas.renderAll();
        };

        $scope.updateMaxSizePx = function (size = 0, object) {
            object.setMaxSizePx(size);
            canvas.renderAll();
        };

        $scope.updateOpacity = function (opacity, object) {
            object.setOpacity(opacity);
            canvas.renderAll();
        };

        $scope.bringElementToFront = async function (element) {
            $scope.layersInstance.$children[0].bringElementToFront(element);
            recordFeatureUsage(TrackedFeature.ArrangeBringToFront);
        };

        $scope.sendElementToBack = async function (element) {
            $scope.layersInstance.$children[0].sendElementToBack(element);
            recordFeatureUsage(TrackedFeature.ArrangeSendToBack);
        };

        $scope.moveElementForward = async function (element) {
            $scope.layersInstance.$children[0].moveElementForward(element);
            recordFeatureUsage(TrackedFeature.ArrangeBringForward);
        };

        $scope.moveElementBackward = async function (element) {
            $scope.layersInstance.$children[0].moveElementBackward(element);
            recordFeatureUsage(TrackedFeature.ArrangeSendBackward);
        };

        $scope.onArrangeLayer = function (element, position) {
            const action = {
                forward: $scope.moveElementForward,
                backward: $scope.moveElementBackward,
                front: $scope.bringElementToFront,
                back: $scope.sendElementToBack
            };
            action[position]?.(element);
        };

        $scope.updateZIndex = async function (zIndex, object) {
            if (object.isType('activeSelection')) {
                object.getObjects()?.forEach((o) => {
                    let newZIndex = o.zIndex + zIndex;

                    // Z index can't go over the length of the list
                    if (newZIndex < 0) newZIndex = 0;
                    else if (newZIndex > canvas.getObjects().length - 1) newZIndex = canvas.getObjects().length - 1;

                    // Set the z index for this object
                    o.zIndex = newZIndex;
                    canvas.moveTo(o, newZIndex);
                });
            } else {
                // Z index can't go over the length of the list
                if (zIndex < 0) zIndex = 0;
                else if (zIndex > canvas.getObjects().length - 1) zIndex = canvas.getObjects().length - 1;

                // Set the z index for this object
                object.zIndex = zIndex;
                canvas.moveTo(object, zIndex);
            }

            canvas.renderAll();

            // update text masks
            await $scope.handleTextAsMaskOnZIndexUpdated();
        };

        ///////////////////////////////////////////////////////////////////////////////////////////
        /// Color pickers                                                                       ///
        ///////////////////////////////////////////////////////////////////////////////////////////
        var cancelNextImageColorChangeDebounced = false;
        var debouncedImageColorChange = _.debounce(function (colors, imageSelected) {
            if (!cancelNextImageColorChangeDebounced && imageSelected) {
                imageSelected.set('imageColor', `#${colors.HEX}`);
                canvas.renderAll();
            }
            cancelNextImageColorChangeDebounced = false;
        }, 300);

        $scope.imageColorChange = function (colors, isTerminating) {
            if (isTerminating && $scope.imageSelected) {
                $scope.imageSelected.set('imageColor', `#${colors.HEX}`);
                canvas.renderAll();
            } else {
                debouncedImageColorChange(colors, $scope.imageSelected);
            }
        };

        $scope.imageColorSave = function (colors, image) {
            image = image || $scope.imageSelected;
            const { selectedImageProperties, editMode } = $scope;
            if (image?.isPrintArea) {
                image.fullColor = false;
                image.grading = false;
                image.imageType = 'single color';
                selectedImageProperties.fullColor = false;
                selectedImageProperties.grading = false;
                image.setMode(fabric.IMAGE_MODE_SINGLE_COLOR);
                image.colors = undefined;
                image.colorLibraryId = undefined;
                if (editMode) {
                    image.setEditedProp('fullColor', 'grading', 'colors', 'colorLibraryId', 'imageType');
                }
            }
            if (image) {
                DynamicImageService.saveDynamicImageColor(colors, image, editMode);
                image.set('imageColor', `#${colors.HEX}`);
                canvas.renderAll();
            }
        };

        $scope.startFillColorSampler = function (colorPicker) {
            $scope.colorSamplerActive = true;
            ColorSamplerService.startColorSampler(canvas, colorPicker, canvas.getActiveObject(), 'fill');
        };

        $scope.startOutlineColorSampler = function (colorPicker) {
            $scope.colorSamplerActive = true;
            ColorSamplerService.startColorSampler(canvas, colorPicker, canvas.getActiveObject(), 'outline');
        };

        //product base creation
        $scope.applyMask = function (fileObject) {
            $scope.selectedImageProperties.clipPath.scaleX = 1;
            const svgFile = fileObject.files[0];
            const reader = new FileReader();
            const selectedImage = canvas.getActiveObject();

            reader.onloadend = function (e) {
                var svgData = e.target.result;
                var parser = new DOMParser();
                var doc = parser.parseFromString(svgData, 'image/svg+xml');
                const maskPath = [...doc.querySelectorAll('path')].map((path) => path.getAttribute('d'))[0];
                const mask = new fabric.Path(maskPath, {
                    left: 0, // Center of the canvas
                    top: 0, // Center of the canvas
                    originX: 'center',
                    originY: 'center'
                });
                selectedImage.clipPath = mask;
                //force image redraw for mask to be applied inmedialty
                selectedImage.set('dirty', true);
                canvas.renderAll();
            };
            reader.readAsText(svgFile);
        };

        $scope.changeMaskScale = function (maskSize) {
            const selectedImage = canvas.getActiveObject();
            selectedImage.clipPath.scale(maskSize);
            selectedImage.set('dirty', true);
            canvas.renderAll();
        };

        $scope.changeMaskXY = function (x, y) {
            const selectedImage = canvas.getActiveObject();
            selectedImage.clipPath.left = x;
            selectedImage.clipPath.top = y;
            selectedImage.set('dirty', true);
            canvas.renderAll();
        };

        /****************************************************************************/
        /****************************** AUX FUNCTIONS *******************************/
        /****************************************************************************/
        $scope.getLastObjectId = function () {
            let objects = canvas.getObjects();
            let id = 0;
            for (let n = 0; n < objects.length; ++n) {
                id = Math.max(id, objects[n].id);
            }
            return id;
        };

        $scope.updateId = function (newId, object) {
            if (newId) {
                object.id = newId;
            }
        };

        // Cleanup
        $scope.$on('$destroy', function () {
            console.log('Cleaning up resources from step 2');

            $scope.imageColorPicker.destroy();
            $scope.imageOutlineColorPicker.destroy();

            blockUI.stop();

            if (canvas) {
                // Remove the canvas element so the next controller won't be able to find it
                canvas.dispose();
                $('#fabric-container-2').remove();
            }
        });

        ///////////////////////////////////////////////////////////////////////////////////////////
        /// Libraries                                                                           ///
        ///////////////////////////////////////////////////////////////////////////////////////////
        $scope.pickColorLibrary = async function (canvasObject, loadInfo = true) {
            return LibrariesUtilService.showColorLibraryPicker().then(function (library) {
                if (library) {
                    canvasObject.colorLibraryId = library.LibraryId;

                    if (!loadInfo) return;

                    // Select the first color from the library
                    if (canvasObject.type === 'image-placeholder') {
                        $scope.selectedImageProperties.colorPosition = 1;
                        DynamicImageService.changeDynamicImageColorPosition(
                            canvasObject,
                            1,
                            $scope.imageColorPicker,
                            canvas
                        );
                    }

                    // Get the name of the selected library
                    LibrariesAPIService.getLibraryName(library.LibraryId).then(function (name) {
                        $scope.selectedColorLibraryName = name;
                    });
                }
            });
        };

        $scope.pickColorLibraryForSelectedVector = async function () {
            const object = canvas.getActiveObject();
            // Re-initialize vectorSelected in order for vue component to detect the change
            $scope.svgSelected = null;
            await $scope.pickColorLibrary(object, false);

            $scope.svgSelected = object;
            $scope.$apply();
        };

        $scope.pickColorLibraryForSelectedImage = async function () {
            const object = canvas.getActiveObject();
            $scope.imageSelected = null;
            await $scope.pickColorLibrary(object, false);

            if ($scope.isEditMode && typeof $scope.setEditedProp === 'function') {
                $scope.setEditedProp('colorLibraryId');
            }
            $scope.imageSelected = object;
            $scope.$apply();
        };

        $scope.pickColorLibraryForSelectedText = function () {
            const object = canvas.getActiveObject();
            $scope.textSelected = null;
            LibrariesUtilService.showColorLibraryPicker().then((library) => {
                object.colorLibraryId = library?.LibraryId;
                $scope.textSelected = object;
                if (object?.pattern) $scope.resyncPattern(object);
                $scope.$apply();
            });
        };

        $scope.pickOutlineColorLibraryForSelectedText = function () {
            const object = canvas.getActiveObject();
            $scope.textSelected = null;
            LibrariesUtilService.showColorLibraryPicker().then((library) => {
                object.outlineColorLibraryId = library?.LibraryId;
                $scope.textSelected = object;
                if (object?.pattern) $scope.resyncPattern(object);
                $scope.$apply();
            });
        };

        $scope.pickStrokeColorLibraryForSelectedText = async function () {
            const object = canvas.getActiveObject();
            $scope.textSelected = null;
            const library = await LibrariesUtilService.showColorLibraryPicker();

            if (!library) {
                $scope.textSelected = object;
                return;
            }

            object.strokeColorLibraryId = library.LibraryId;

            $scope.textSelected = object;
            if (object?.pattern) $scope.resyncPattern(object);
            $scope.$apply();
        };

        $scope.pickShadowColorLibraryForSelectedImage = async function () {
            const object = canvas.getActiveObject();
            // Re-initialize imageSelected in order for vue component to detect the change
            $scope.imageSelected = null;
            LibrariesUtilService.showColorLibraryPicker().then((library) => {
                // Cancelling the picker has to leave the current library alone
                if (library) {
                    object.shadowColorLibraryId = library.LibraryId;
                }
                $scope.imageSelected = object;
                $scope.$apply();
            });
        };

        $scope.pickShadowColorLibraryForSelectedText = async function () {
            const object = canvas.getActiveObject();
            $scope.textSelected = null;
            LibrariesUtilService.showColorLibraryPicker().then((library) => {
                // Cancelling the picker has to leave the current library alone
                if (library) {
                    object.shadowColorLibraryId = library.LibraryId;
                }
                $scope.textSelected = object;
                if (object?.pattern) $scope.resyncPattern(object);
                $scope.$apply();
            });
        };

        $scope.removeColorLibrary = function (canvasObject) {
            canvasObject.colorLibraryId = null;

            // Reset the position to 1 when removing the library
            if (canvasObject.type === 'image-placeholder') {
                $scope.selectedImageProperties.colorPosition = 1;
                DynamicImageService.changeDynamicImageColorPosition(canvasObject, 1, $scope.imageColorPicker, canvas);
            }
        };

        $scope.pickImageLibraryForSelectedImage = async function () {
            const object = canvas.getActiveObject();
            // Re-initialize imageSelected in order for vue component to detect the change
            $scope.imageSelected = null;
            const library = await LibrariesUtilService.showImageLibraryPicker(object.isColorOptions);

            if (!library) {
                $scope.imageSelected = object;
                return;
            }

            object.imageLibraryId = library.LibraryId;

            $scope.imageSelected = object;
            $scope.$apply();
        };

        $scope.onLibraryChangeForSelectedImage = function (libraryDetails) {
            if (!$scope.imageSelected?.isColorOptions) return;
            const activePreview = ProductService.getPreview();
            if (!activePreview.isDefault) return;
            const details = libraryDetails ?? {
                elements: []
            };
            ProductService.setProductColorsLibraryDetails(libraryDetails);
        };

        $scope.showPlaceholderImgForSelectedImage = function (dynamicImage = null) {
            const image = dynamicImage || canvas.getActiveObject();
            DynamicImageService.showSampleDynamicImage(canvas, image);
        };

        $scope.updateProductColorMetadata = function (imageFiles) {
            if (ProductService.getPod()) {
                ProductService.setIsProductColorModified(true);
            }
            ProductService.setProductColorsFilenames(imageFiles);
            // process text mask
            TextService.processTextMask(canvas, $scope, [$scope.imageSelected]);
        };

        $scope.downloadCurrentCanvasAsImage = async function () {
            if (!canvas) return;
            await handleDownloadCurrentCanvasAsImage(canvas, ProductService.getProduct().name);
        };

        $scope.selectInnerRectangle = function (activeObject) {
            activeObject.fire('object:dblclick');
        };

        $scope.onCalendarDateChange = () => {
            $scope._generateCustomilyCalendar($scope.imageSelected);
        };

        $scope.customilyCalendar = {
            date: new Date()
        };

        $scope._generateCustomilyCalendar = _.debounce(async function (object) {
            try {
                const output = await generateCustomilyCalendar(object, $scope.customilyCalendar.date);
                TestImageService.showStaticImage(canvas, object, {
                    imageUrl: output
                });
                return output;
            } catch (error) {
                console.error('generateCustomilyCalendar', error);
            }
        }, 200);

        const TEXT_EFFECT = createTextEffect({ canvas, $scope, TextService, ProductService });
        const { applyTextEffect, removeTextEffect, updateTextEffect } = createTextEffectHandlers({
            getCanvas: () => canvas,
            $scope,
            DynamicImageService,
            TestImageService,
            TextService,
            ProductService
        });

        const patternHandlers = createTextPatternHandlers({
            getCanvas: () => canvas,
            $scope,
            TextService,
            ProductService
        });

        $scope.resyncPattern = function (origin) {
            if (origin && origin.type === 'bounded-text' && origin.pattern) {
                patternHandlers.resyncReplicas(origin);
            }
        };

        $scope.repositionPattern = function (origin, resize) {
            if (origin && origin.type === 'bounded-text' && origin.pattern) {
                patternHandlers.repositionReplicas(origin, { resize: !!resize });
            }
        };

        $scope.onElementPropsUpdated = function (value) {
            const obj = canvas.getObjects().find((o) => o.uuid === value && o.type === 'bounded-text');
            if (obj?.pattern) $scope.resyncPattern(obj);
        };

        $scope.relockPatternReplica = async function (replica) {
            const origin = canvas.getObjects().find((o) => o.uuid === replica.patternOriginUuid);
            if (!origin || !origin.patternConfig || !replica.patternCell) return;
            const pos = computeCellPosition(origin, origin.patternConfig, replica.patternCell);
            await TextService.syncPatternReplica(canvas, origin, replica, pos);
            canvas.requestRenderAll();
        };

        $scope.cleanupDeletedPatterns = function (deleted) {
            if (!deleted || !deleted.length) return;
            for (const element of deleted) {
                if (element.type !== 'bounded-text') continue;
                if (element.pattern) {
                    for (const replica of TextService.getPatternReplicaObjects(canvas, element.uuid)) {
                        canvas.remove(replica);
                    }
                    ProductService.removePatternElementsLinks(element.uuid);
                } else if (element.isPatternReplica) {
                    ProductService.removePatternElementsLinkByReplica(element.uuid);
                }
            }
            updateElementsOrderFromZIndex(canvas);
        };

        $scope.handleTextAsMaskOnZIndexUpdated = async function () {
            const updaters = [
                { filter: 'useAsMask', toggle: $scope.updateTextUseAsMask },
                { filter: 'useAsCutout', toggle: $scope.updateTextUseAsCutout }
            ];
            for (const { filter, toggle } of updaters) {
                for (const o of canvas._objects.filter((o) => o.type === 'bounded-text' && o[filter])) {
                    await toggle(false, o, true);
                    await toggle(true, o, true);
                }
            }
        };

        $scope.updateTextUseAsMask = async function (useAsMask, object, reorderLayers = false) {
            await updateTextEffect(useAsMask, object, reorderLayers, TEXT_EFFECT.mask);
        };

        $scope.updateTextUseAsCutout = async function (useAsCutout, object, reorderLayers = false) {
            await updateTextEffect(useAsCutout, object, reorderLayers, TEXT_EFFECT.cutout);
        };

        $scope.applyTextMask = (uuid) => applyTextEffect(uuid, TEXT_EFFECT.mask);
        $scope.applyTextCutout = (uuid) => applyTextEffect(uuid, TEXT_EFFECT.cutout);
        $scope.removeTextMask = (t, o) => removeTextEffect(t, o, TEXT_EFFECT.mask);
        $scope.removeTextCutout = (t, o) => removeTextEffect(t, o, TEXT_EFFECT.cutout);

        $scope.imageHasTextLink = function (image) {
            if (!image) return false;
            return ProductService.getElementsLinks().some(
                (l) => l.targetId === image.uuid && (l.valueFormat === 3 || l.valueFormat === 4)
            );
        };

        $scope.applyTextMasks = async function () {
            for (const o of canvas._objects.filter((o) => o.type === 'bounded-text' && o.useAsMask)) {
                await $scope.updateTextUseAsMask(true, o);
            }
            for (const o of canvas._objects.filter((o) => o.type === 'bounded-text' && o.useAsCutout)) {
                await $scope.updateTextUseAsCutout(true, o);
            }
        };

        if (!$scope.previewMode) {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            $scope.$on('$locationChangeStart', function (event, next, current) {
                if (!next.includes('/createProduct')) {
                    if (
                        !confirm(
                            "You're about to exit the template. This means all changes will be lost, do you want to continue?"
                        )
                    ) {
                        event.preventDefault();
                        ProductService.clearChildTemplateProduct();
                        $location.url($location.path());
                    } else {
                        $location.url(`${new URL(next).pathname}`);
                        ProductService.clearProduct();
                    }
                }
                $rootScope.lastLocation = current;
            });
        }

        $scope.stepTwoLayersSettingsProps = {
            title: 'Preview',
            events: {
                toggleLock: $scope.layersElementLockToggle,
                toggleVisibility: $scope.layersElementVisibilityToggle,
                toggleOverlay: $scope.layersElementOverlayToggle,
                titleChanged: $scope.layersTitleChange
            },
            canvas: $scope.canvas
        };
    }
})();
